// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Light-render native form controls (checkboxes, selects, spinners). */
  color-scheme: light;
  /* Dark auth-hero base (login/signup radial). Neutral, not navy. */
  --bg: #0a0a0a;
  --surface: #ffffff;
  --surface-2: #f8fafc;
  --border: #e2e8f0;
  /* Fainter line used only for in-table grid rules (row/column dividers). */
  --table-line: rgba(15, 23, 42, 0.06);
  --text: #0f172a;
  --text-sub: #64748b;
  --muted: #94a3b8;
  --primary: #3C87F7;
  --primary-dark: #1D68D9;
  --primary-tint: #eaf2fe;
  --shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  --radius: 12px;
  /* Market Map choropleth: brand-blue sequential ramp (base → accent), a
     neutral fill for states with no data, and a state-border stroke. */
  --map-base: #e6f0fe;
  --map-accent: #1D68D9;
  --map-null: #eef1f5;
  --map-stroke: #ffffff;
  --topbar-bg: rgba(255, 255, 255, 0.85);
  --scrollbar-thumb: rgba(100, 116, 139, 0.14);
  --scrollbar-thumb-hover: rgba(100, 116, 139, 0.28);
}

* {
  box-sizing: border-box;
}

/* ---------- No focus outline, site-wide ----------
   Removes the browser's default focus ring on every focusable element
   (buttons, links, nav items, section toggles, etc.) whether reached by
   click or by keyboard Tab. Applies to both :focus and :focus-visible so
   nothing shows a stock blue outline anywhere on the app. */
*:focus,
*:focus-visible {
  outline: none !important;
}
/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) transparent;
}

/* WebKit / Chromium / Safari */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 999px;
  /* Transparent border + padding-box clip keeps the visible thumb slim
     and inset from the track edges. */
  border: 2px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
  background-clip: padding-box;
}

/* ---------- Hidden scrollbar ----------
   The container still scrolls (wheel, trackpad, keys, touch) but draws no bar.
   Used ONLY on the Main story view's scroll container in DraftFlowView — a
   reading surface, not a workbench. */
.no-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* legacy Edge/IE */
}

.no-scrollbar::-webkit-scrollbar {
  display: none; /* WebKit / Chromium / Safari */
}

/* ---------- Autofilled fields ----------
   Browsers force their own light background (Chrome uses rgb(232, 240, 254))
   and text colour onto autofilled inputs, which breaks the theme — the field
   flashes light even in dark mode. The background can't be overridden directly
   on :-webkit-autofill, so we paint over it with a large inset box-shadow in
   the field's own colour and force the text fill colour. Driven by theme
   variables, so it stays correct in both light and dark. */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:active {
  -webkit-text-fill-color: var(--text);
  caret-color: var(--text);
  box-shadow: 0 0 0 1000px var(--surface) inset;
}

/* Keep the focus ring on top of the autofill fill. */
input:-webkit-autofill:focus,
textarea:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--text);
  caret-color: var(--text);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2), 0 0 0 1000px var(--surface) inset;
}

/* Auth pages are always dark regardless of theme — autofill must fill the
   pill's own dark color, not the light theme's --surface. */
.auth-dark input:-webkit-autofill,
.auth-dark input:-webkit-autofill:hover,
.auth-dark input:-webkit-autofill:focus,
.auth-dark input:-webkit-autofill:active {
  -webkit-text-fill-color: #f5f5f5;
  caret-color: #f5f5f5;
  box-shadow: 0 0 0 1000px #1b1b1b inset;
}

/* MultiStepForm fields sit on --surface-2 (bg-panel), so match
   that instead of --surface. */
[id^='msf-']:-webkit-autofill,
[id^='msf-']:-webkit-autofill:hover,
[id^='msf-']:-webkit-autofill:active {
  box-shadow: 0 0 0 1000px var(--surface-2) inset;
}
[id^='msf-']:-webkit-autofill:focus {
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2), 0 0 0 1000px var(--surface-2) inset;
}

html,
body,
#root {
  margin: 0;
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
  color: var(--text);
  background: var(--surface-2);
  -webkit-font-smoothing: antialiased;
}

button {
  font-family: inherit;
  cursor: pointer;
}

/* Native inputs default to UA fonts (textarea: monospace) — use the app font. */
input,
textarea,
select {
  font-family: inherit;
}

/* ---------- Brand ---------- */
.logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  flex: none;
}

.brand-name {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.2;
}

.brand-sub {
  font-size: 12px;
  color: var(--text-sub);
}

/* ---------- Login ---------- */
.login-shell {
  min-height: 100%;
  display: grid;
  place-items: center;
  padding: 24px;
  background: radial-gradient(1200px 600px at 50% -10%, #242424, var(--bg));
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: var(--surface);
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 20px 50px rgba(2, 6, 23, 0.45);
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-sub);
}

.login-form input {
  padding: 11px 13px;
  border: 1px solid var(--border);
  border-radius: 9px;
  font-size: 15px;
  color: var(--text);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.login-form input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

.login-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  padding: 9px 12px;
  border-radius: 8px;
  font-size: 13px;
}

.login-hint {
  margin-top: 18px;
  text-align: center;
  font-size: 12px;
  color: var(--muted);
}

.login-link {
  color: var(--primary-dark);
  font-weight: 600;
  text-decoration: none;
}

.login-link:hover {
  text-decoration: underline;
}

/* ---------- Buttons ---------- */
.btn-primary {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 11px 18px;
  border-radius: 9px;
  font-size: 15px;
  font-weight: 600;
  transition: background 0.15s;
}

.btn-primary:hover {
  background: var(--primary-dark);
}

.btn-full {
  width: 100%;
}

.btn-ghost {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-sub);
  padding: 7px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.15s, color 0.15s;
}

.btn-ghost:hover {
  background: var(--surface-2);
  color: var(--text);
}

/* ---------- App shell ---------- */
.app-shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.topbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.topbar-user {
  display: flex;
  align-items: center;
  gap: 14px;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
}

.content {
  padding: 24px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}

/* ---------- KPI ---------- */
.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.kpi-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px 20px;
  box-shadow: var(--shadow);
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.kpi-label {
  font-size: 13px;
  color: var(--text-sub);
  margin-top: 4px;
}

/* ---------- Controls ---------- */
.controls {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.search {
  flex: 1;
  min-width: 240px;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 9px;
  font-size: 14px;
  background: var(--surface);
}

.search:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

.status-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: var(--surface);
  font-size: 13px;
  font-weight: 600;
  color: var(--text-sub);
  transition: all 0.15s;
}

.chip:hover {
  border-color: var(--muted);
}

.chip-active {
  background: var(--primary-tint);
  border-color: var(--primary);
  color: var(--primary-dark);
}

.chip-count {
  background: var(--surface-2);
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 11px;
  color: var(--text-sub);
}

.chip-active .chip-count {
  background: #dbeafe;
  color: var(--primary-dark);
}

.results-meta {
  font-size: 13px;
  color: var(--text-sub);
  margin-bottom: 12px;
}

/* ---------- Region select ---------- */
.region-select {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-sub);
}

.region-select select {
  padding: 9px 12px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: var(--surface);
  font-size: 14px;
  font-weight: 500;
  color: var(--text);
  min-width: 260px;
  cursor: pointer;
}

.region-select select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

/* ---------- Row selection + enrich ---------- */
.enrich-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 16px;
  margin-bottom: 12px;
  background: var(--primary-tint);
  border: 1px solid #bfdbfe;
  border-radius: 10px;
}

.enrich-count {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-dark);
}

.enrich-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-sm {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  font-size: 13px;
}

.btn-icon {
  width: 16px;
  height: 16px;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.enrich-status {
  display: inline-block;
  margin-bottom: 12px;
  padding: 8px 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #15803d;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
}

.leads-table th.check,
.leads-table td.check {
  width: 44px;
  text-align: center;
  padding-left: 14px;
  padding-right: 0;
}

.leads-table td.check input,
.leads-table th.check input {
  width: 16px;
  height: 16px;
  accent-color: var(--primary);
  cursor: pointer;
  vertical-align: middle;
}

.leads-table tbody tr.selected {
  background: var(--primary-tint);
}

.leads-table tbody tr.selected:hover {
  background: #dbeafe;
}

.badge-enriched {
  display: inline-block;
  margin: 2px 0;
  background: #f0fdf4;
  color: #15803d;
}

/* ---------- Company table extras ---------- */
.company-table {
  min-width: 1100px;
}

.cell-link {
  display: inline-block;
  font-size: 12.5px;
  color: var(--primary-dark);
  text-decoration: none;
  margin-top: 2px;
}

.cell-link:hover {
  text-decoration: underline;
}

.trade-cell {
  display: inline-block;
  max-width: 260px;
}

.tag {
  display: inline-block;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 2px 7px;
  font-size: 11.5px;
  color: var(--text-sub);
  margin: 0 4px 4px 0;
  white-space: nowrap;
}

.tag-more {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--muted);
}

/* ---------- Pagination ---------- */
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 14px;
}

.pagination-info {
  font-size: 13px;
  color: var(--text-sub);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pagination-page {
  font-size: 13px;
  color: var(--text-sub);
  min-width: 110px;
  text-align: center;
}

.btn-ghost:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ---------- Clickable table rows ---------- */
.leads-table tbody tr.row-link {
  cursor: pointer;
}

/* ---------- Sequence builder ---------- */
.builder-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.name-input {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  border: 1px solid var(--primary);
  border-radius: 8px;
  padding: 4px 10px;
  width: min(520px, 100%);
}

.page-title .title-edit {
  width: 16px;
  height: 16px;
  color: var(--muted);
  opacity: 0;
  vertical-align: middle;
  transition: opacity 0.12s;
}

.page-title:hover .title-edit {
  opacity: 1;
}

.seq-timeline {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 720px;
}

.seq-wait {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin: 8px 0 8px 34px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-sub);
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 999px;
}

.seq-wait-icon {
  width: 13px;
  height: 13px;
}

.seq-step {
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 14px 16px;
  box-shadow: var(--shadow);
}

.seq-step-day {
  flex: none;
  width: 52px;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-sub);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.seq-step-icon {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--primary-tint);
  color: var(--primary);
  display: grid;
  place-items: center;
}

.seq-step-icon svg {
  width: 20px;
  height: 20px;
}

.seq-step-body {
  flex: 1;
  min-width: 0;
}

.seq-step-type {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chip-auto {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--primary-dark);
  background: var(--primary-tint);
  border-radius: 999px;
  padding: 1px 7px;
}

.seq-step-summary {
  font-size: 13px;
  color: var(--text-sub);
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.seq-step-actions {
  flex: none;
  display: flex;
  gap: 4px;
}

.icon-btn-sm {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: none;
  background: transparent;
  border-radius: 7px;
  color: var(--muted);
}

.icon-btn-sm svg {
  width: 16px;
  height: 16px;
}

.icon-btn-sm:hover {
  background: var(--surface-2);
  color: var(--text);
}

.icon-btn-sm.danger:hover {
  background: #fef2f2;
  color: #dc2626;
}

.seq-connector {
  width: 2px;
  height: 20px;
  background: var(--border);
  margin: 4px 0 4px 33px;
}

.seq-add {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-dark);
}

.seq-add:hover {
  border-color: var(--primary);
  background: var(--primary-tint);
}

/* ---------- Modal ---------- */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: grid;
  place-items: center;
  padding: 24px;
  z-index: 100;
}

.modal {
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  background: var(--surface);
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(2, 6, 23, 0.4);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid var(--border);
}

.modal-header h3 {
  margin: 0;
  font-size: 17px;
}

.modal-close {
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: var(--muted);
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border);
}

.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-sub);
  margin: 14px 0 6px;
}

.field-label:first-child {
  margin-top: 0;
}

.field-input,
.field-textarea {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid var(--border);
  border-radius: 9px;
  font-size: 14px;
  font-family: inherit;
  color: var(--text);
}

.field-textarea {
  resize: vertical;
}

.field-input:focus,
.field-textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

.field-hint {
  font-size: 12px;
  color: var(--muted);
  margin-top: 6px;
}

.field-static {
  font-size: 13px;
  color: var(--text-sub);
  padding: 9px 12px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 9px;
}

.field-optional {
  font-weight: 400;
  color: var(--muted);
  text-transform: none;
}

/* AI email drafter inside the Compose modal */
.draft-assist {
  margin: 14px 0 4px;
}

.draft-assist-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.draft-assist-panel {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px;
  background: var(--surface-2);
}

.draft-assist-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 4px;
}

.draft-assist-panel .field-label:first-child {
  margin-top: 8px;
}

.draft-assist-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.draft-assist-actions .btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.delay-field {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--text-sub);
}

.delay-field input {
  width: 72px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
}

.steptype-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.steptype {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  text-align: left;
}

.steptype:hover {
  border-color: var(--muted);
}

.steptype.selected {
  border-color: var(--primary);
  background: var(--primary-tint);
  color: var(--primary-dark);
  font-weight: 600;
}

.steptype-icon {
  width: 18px;
  height: 18px;
  flex: none;
}

/* ---------- Collaboration / invite ---------- */
.invite-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px 20px;
  box-shadow: var(--shadow);
  margin-bottom: 22px;
}

.invite-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.invite-card-icon {
  width: 22px;
  height: 22px;
  color: var(--primary);
  flex: none;
}

.invite-card-title {
  font-weight: 700;
  font-size: 15px;
}

.invite-card-sub {
  font-size: 13px;
  color: var(--text-sub);
}

.invite-form {
  display: grid;
  grid-template-columns: 1fr 1fr auto auto;
  gap: 10px;
  align-items: center;
}

.invite-msg {
  margin-top: 12px;
}

.member-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-sm {
  width: 34px;
  height: 34px;
  font-size: 12px;
}

@media (max-width: 720px) {
  .invite-form {
    grid-template-columns: 1fr;
  }
}

/* ---------- Table ---------- */
.table-wrap {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: auto;
  box-shadow: var(--shadow);
}

.leads-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.leads-table thead th {
  position: sticky;
  top: 0;
  background: var(--surface-2);
  text-align: left;
  padding: 12px 14px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-sub);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.leads-table th.sortable {
  cursor: pointer;
}

.leads-table th.sortable:hover {
  color: var(--text);
}

.leads-table th.num,
.leads-table td.num {
  text-align: right;
}

.sort-caret {
  color: var(--primary);
  font-size: 10px;
}

.leads-table tbody td {
  padding: 11px 14px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}

.leads-table tbody tr:last-child td {
  border-bottom: none;
}

.leads-table tbody tr:hover {
  background: var(--surface-2);
}

.cell-name {
  font-weight: 600;
}

.cell-sub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.mono {
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12.5px;
  color: var(--text-sub);
}

.muted {
  color: var(--muted);
}

/* ---------- Badges ---------- */
.badge {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-new {
  background: #eff6ff;
  color: #1d4ed8;
}
.badge-contacted {
  background: #f5f3ff;
  color: #6d28d9;
}
.badge-quoted {
  background: #fefce8;
  color: #a16207;
}
.badge-scheduled {
  background: #ecfeff;
  color: #0e7490;
}
.badge-won {
  background: #f0fdf4;
  color: #15803d;
}
.badge-lost {
  background: #fef2f2;
  color: #b91c1c;
}

/* ---------- DataTable (shared) ---------- */
.dt {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Tabs */
.dt-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 2px;
}

.dt-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--text-sub);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.dt-tab:hover {
  background: var(--surface-2);
  color: var(--text);
}

.dt-tab.is-active {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
  box-shadow: var(--shadow);
}

.dt-tab-icon {
  width: 15px;
  height: 15px;
  opacity: 0.7;
}

.dt-tab-count {
  background: var(--surface-2);
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-sub);
}

.dt-tab.is-active .dt-tab-count {
  background: var(--primary-tint);
  color: var(--primary-dark);
}

/* Toolbar */
.dt-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.dt-toolbar-left,
.dt-toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dt-toolbar-left {
  flex: 1;
  min-width: 200px;
}

.dt-search {
  position: relative;
  flex: 1;
  max-width: 320px;
  min-width: 180px;
}

.dt-search-icon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  color: var(--muted);
  pointer-events: none;
}

.dt-search input {
  width: 100%;
  padding: 9px 12px 9px 33px;
  border: 1px solid var(--border);
  border-radius: 9px;
  font-size: 14px;
  background: var(--surface);
  color: var(--text);
}

.dt-search input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

.dt-filter {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: var(--surface);
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.dt-filter:hover {
  background: var(--surface-2);
}

.dt-filter svg {
  width: 15px;
  height: 15px;
  color: var(--text-sub);
}

.dt-count {
  background: var(--primary-tint);
  color: var(--primary-dark);
  border-radius: 999px;
  padding: 1px 7px;
  font-size: 11px;
}

.dt-linkbtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: none;
  background: transparent;
  color: var(--text-sub);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
}

.dt-linkbtn:hover {
  background: var(--surface-2);
  color: var(--text);
}

.dt-linkbtn svg {
  width: 15px;
  height: 15px;
}

/* Table shell */
.dt-wrap {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow: auto;
  box-shadow: var(--shadow);
}

.dt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.dt-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--surface);
  text-align: left;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-sub);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.dt-th {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.dt-th-icon {
  width: 15px;
  height: 15px;
  opacity: 0.65;
}

.dt-table th.dt-sortable {
  cursor: pointer;
}

.dt-table th.dt-sortable:hover {
  color: var(--text);
}

.dt-caret {
  color: var(--primary);
  font-size: 9px;
  width: 9px;
}

.dt-table th.dt-right,
.dt-table td.dt-right {
  text-align: right;
}

.dt-table th.dt-right .dt-th {
  flex-direction: row-reverse;
}

.dt-table th.dt-center,
.dt-table td.dt-center {
  text-align: center;
}

.dt-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
  color: var(--text);
}

.dt-table tbody tr:last-child td {
  border-bottom: none;
}

.dt-table tbody tr:hover {
  background: var(--surface-2);
}

.dt-table tbody tr.dt-rowlink {
  cursor: pointer;
}

.dt-table tbody tr.is-selected {
  background: var(--primary-tint);
}

.dt-check {
  width: 40px;
  text-align: center;
  padding-left: 14px !important;
  padding-right: 0 !important;
}

.dt-check input {
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: var(--primary);
}

.dt-empty-row td {
  padding: 0 !important;
}

.dt-empty {
  padding: 40px;
  text-align: center;
  color: var(--text-sub);
}

/* Status pills (icon + label) */
.dt-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.dt-pill-icon {
  width: 13px;
  height: 13px;
}

.dt-pill-neutral {
  background: var(--surface-2);
  color: var(--text-sub);
}
.dt-pill-warning {
  background: #fefce8;
  color: #a16207;
}
.dt-pill-success {
  background: #f0fdf4;
  color: #15803d;
}
.dt-pill-info {
  background: #eff6ff;
  color: #1d4ed8;
}
.dt-pill-danger {
  background: #fef2f2;
  color: #b91c1c;
}
.dt-pill-purple {
  background: #f5f3ff;
  color: #6d28d9;
}

/* Pagination */
.dt-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.dt-pagination-info {
  font-size: 13px;
  color: var(--text-sub);
}

.dt-pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dt-pagination-page {
  font-size: 13px;
  color: var(--text-sub);
}

:root[data-theme='dark'] .dt-pill-warning {
  background: rgba(161, 98, 7, 0.18);
  color: #fbbf24;
}
:root[data-theme='dark'] .dt-pill-success {
  background: rgba(21, 128, 61, 0.18);
  color: #4ade80;
}
:root[data-theme='dark'] .dt-pill-info {
  background: rgba(29, 78, 216, 0.2);
  color: #93bdfb;
}
:root[data-theme='dark'] .dt-pill-danger {
  background: rgba(185, 28, 28, 0.2);
  color: #fca5a5;
}
:root[data-theme='dark'] .dt-pill-purple {
  background: rgba(109, 40, 217, 0.22);
  color: #c4b5fd;
}
:root[data-theme='dark'] .dt-table tbody tr.is-selected {
  background: rgba(60, 135, 247, 0.16);
}

/* ---------- States ---------- */
.empty-state,
.error-state {
  padding: 40px;
  text-align: center;
  color: var(--text-sub);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.error-state {
  color: #b91c1c;
}

/* ---------- Search results page ---------- */
.search-page-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 560px;
  margin-bottom: 24px;
  padding: 11px 15px;
  border: 1px solid var(--border);
  border-radius: 11px;
  background: var(--surface);
  color: var(--text-sub);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.search-page-bar:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

.search-page-bar svg {
  width: 18px;
  height: 18px;
  flex: none;
}

.search-page-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 15px;
  color: var(--text);
  outline: none;
}

.search-page-input::-moz-placeholder {
  color: var(--muted);
}

.search-page-input::placeholder {
  color: var(--muted);
}

.search-group {
  margin-bottom: 24px;
}

.search-group-title {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-sub);
  margin: 0 0 10px;
}

.search-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.search-result {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  text-decoration: none;
  transition: border-color 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease;
}

.search-result:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow);
}

.search-result-main {
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.search-result-sub {
  font-size: 13px;
  color: var(--text-sub);
  white-space: nowrap;
}

/* ---------- App layout ---------- */
.layout {
  /* Mirrors the sidebar's current width so viewport-centered chrome (e.g. the
     topbar search) can offset itself past the sidebar. Kept in sync with the
     \`.sidebar\` width rules below. */
  --sidebar-w: 264px;
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.layout:has(.sidebar.sidebar-collapsed) {
  --sidebar-w: 68px;
}

@media (max-width: 860px) {
  .layout {
    --sidebar-w: 220px;
  }
}

/* ---------- Sidebar ---------- */
.sidebar {
  width: 264px;
  flex: none;
  height: 100%;
  background: var(--surface);
  border-right: 1px solid #e9e8e4;
  display: flex;
  flex-direction: column;
  transition: width 0.18s ease;
}

/* Collapsed rail — icons only, labels and workspace text hidden.
   Double-class selector keeps this winning over the responsive
   \`@media (max-width: 860px) .sidebar { width: 220px }\` rule. */
.sidebar.sidebar-collapsed {
  width: 68px;
}

.sidebar-collapsed .sidebar-workspace,
.sidebar-collapsed .nav-item span,
.sidebar-collapsed .nav-section-title {
  display: none;
}

.sidebar-collapsed .sidebar-header {
  justify-content: center;
  padding: 16px 0 10px;
}

.sidebar-collapsed .sidebar-nav {
  padding: 6px 10px 12px;
}

.sidebar-collapsed .nav-section {
  margin-top: 8px;
}

/* In the icon rail there's no room to toggle sections, so always show every
   item regardless of its expanded/collapsed state — snap open, no animation. */
.sidebar-collapsed .nav-collapse {
  grid-template-rows: 1fr;
  transition: none;
}

.sidebar-collapsed .nav-item {
  justify-content: center;
  gap: 0;
  padding: 9px 0;
}

.sidebar-collapsed .sidebar-footer {
  padding: 10px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  /* Extra left padding so the workspace name sits off the sidebar edge. */
  padding: 16px 14px 10px 24px;
}

.logo-mark-lg {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  font-size: 20px;
}

.sidebar-workspace {
  flex: 1;
  min-width: 0;
}

.workspace-name {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.2;
  color: #1c1917;
}

.workspace-plan {
  font-size: 13px;
  color: #8b8781;
}

.workspace-switch {
  background: transparent;
  border: none;
  color: #a8a29e;
  padding: 4px;
  border-radius: 6px;
  display: inline-flex;
}

.workspace-switch svg {
  width: 18px;
  height: 18px;
}

.workspace-switch:hover {
  background: #eceae6;
  color: #57534e;
}

.sidebar-nav {
  flex: 1;
  /* Without min-height:0 a flex child keeps min-height:auto, growing to fit
     all items so overflow-y never engages — this lets the nav shrink and scroll. */
  min-height: 0;
  overflow-y: auto;
  padding: 6px 12px 12px;
  /* Keep the nav scrollable but hide the scrollbar chrome. */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* legacy Edge/IE */
}

.sidebar-nav::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none; /* Chrome/Safari */
}

.nav-section {
  margin-top: 16px;
}

.nav-section:first-child {
  margin-top: 4px;
}

/* Animated collapse wrapper — the grid-rows 0fr→1fr trick smoothly animates
   height without needing to know the content's pixel height. */
.nav-collapse {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.24s ease;
}

.nav-section.open > .nav-collapse,
.nav-group.open > .nav-collapse {
  grid-template-rows: 1fr;
}

.nav-collapse-inner {
  min-height: 0;
  overflow: hidden;
  /* Breathing room so active items' rounded shadows aren't clipped by the
     overflow needed for the height animation. */
  padding: 1px 4px;
  margin: 0 -4px;
}

.nav-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #a8a29e;
  padding: 4px 10px 6px;
  cursor: pointer;
  transition: color 0.12s;
}

.nav-section-title:hover {
  color: #78716c;
}

.nav-section-caret {
  width: 14px;
  height: 14px;
  margin-left: auto;
  color: #a8a29e;
  transition: transform 0.15s ease;
}

.nav-section:not(.open) .nav-section-caret {
  transform: rotate(-90deg);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 10px;
  color: #44403c;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  margin-bottom: 2px;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.nav-item svg {
  width: 20px;
  height: 20px;
  color: #78716c;
  flex: none;
  transition: color 0.15s ease;
}

.nav-item:hover {
  background: #eceae6;
}

.nav-item.active {
  background: #ffffff;
  color: #1c1917;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(28, 25, 23, 0.1), 0 1px 3px rgba(28, 25, 23, 0.06);
}

.nav-item.active svg {
  color: #1c1917;
}

/* ---------- Nav submenus ---------- */
.nav-parent {
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  font: inherit;
}

.nav-parent.active-parent {
  color: #1c1917;
}

.nav-caret {
  width: 16px;
  height: 16px;
  margin-left: auto;
  color: #a8a29e;
  transition: transform 0.15s ease;
}

.nav-group.open .nav-caret {
  transform: rotate(180deg);
}

/* Indented child links, connected by a vertical guide line. */
.nav-submenu {
  position: relative;
  margin: 2px 0 4px;
  padding-left: 30px;
}

.nav-submenu::before {
  content: '';
  position: absolute;
  left: 19px;
  top: 2px;
  bottom: 2px;
  width: 1px;
  background: #dcdad5;
}

.nav-subitem {
  position: relative;
  display: block;
  padding: 8px 10px;
  border-radius: 8px;
  color: #78716c;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.12s, color 0.12s;
}

.nav-subitem:hover {
  background: #eceae6;
  color: #44403c;
}

.nav-subitem.active {
  color: #1c1917;
  font-weight: 600;
}

/* Dark indicator bar overlaying the guide line for the active child. */
.nav-subitem.active::before {
  content: '';
  position: absolute;
  left: -11px;
  top: 6px;
  bottom: 6px;
  width: 2px;
  border-radius: 2px;
  background: #1c1917;
}

/* Collapsed rail: no chevrons, no expanded submenus. */
.sidebar-collapsed .nav-caret,
.sidebar-collapsed .nav-submenu {
  display: none;
}

.sidebar-footer {
  border-top: 1px solid #e9e8e4;
  background: #f0efec;
  padding: 10px 12px;
}

/* ---------- Main content ---------- */
.main {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  background: var(--surface-2);
  display: flex;
  flex-direction: column;
}

.main-topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  background: var(--topbar-bg);
  backdrop-filter: blur(6px);
  z-index: 20;
}

/* Global search, centered on the true viewport center (not just the content
   area): the topbar starts after the sidebar, so we pull the centering point
   back by the sidebar's width. Vertically centered within the topbar. */
.topbar-search {
  position: absolute;
  left: calc(50vw - var(--sidebar-w));
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(460px, 40vw);
  padding: 8px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  color: var(--text-sub);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.topbar-search svg {
  width: 16px;
  height: 16px;
  flex: none;
}

.topbar-search-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 14px;
  color: var(--text);
  outline: none;
}

.topbar-search-input::-moz-placeholder {
  color: var(--muted);
}

.topbar-search-input::placeholder {
  color: var(--muted);
}

.topbar-search:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

/* No room to center a search on narrow screens — hide it. */
@media (max-width: 760px) {
  .topbar-search {
    display: none;
  }
}

/* ---------- Topbar utility icons ---------- */
.topbar-icons {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 6px;
}

.icon-btn {
  position: relative;
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border: none;
  background: transparent;
  border-radius: 9px;
  color: var(--text-sub);
  transition: background 0.12s, color 0.12s;
}

.icon-btn svg {
  width: 20px;
  height: 20px;
}

.icon-btn:hover {
  background: var(--surface-2);
  color: var(--text);
}

.icon-dot {
  position: absolute;
  top: 8px;
  right: 9px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--primary);
  border: 1.5px solid var(--surface);
}

/* ---------- User menu ---------- */
.user-menu {
  position: relative;
}

.user-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 8px 5px 5px;
  border: none;
  background: transparent;
  border-radius: 10px;
  transition: background 0.12s;
}

.user-button:hover {
  background: var(--surface-2);
}

.avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #18181b;
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  flex: none;
}

.user-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.user-button .user-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.user-role {
  font-size: 12px;
  color: var(--text-sub);
}

.user-caret {
  width: 16px;
  height: 16px;
  color: var(--muted);
  transition: transform 0.15s;
}

.user-caret.up {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 244px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
  padding: 6px;
  z-index: 50;
  transform-origin: top right;
  animation: menuReveal 0.16s ease;
}

/* The exact reverse of menuReveal. A conditionally-rendered popover unmounts
   instantly, so closing looked like a hard cut against a 0.16s open; the menu
   keeps itself mounted for the length of this animation instead. */
@keyframes menuHide {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }
}

/* Reveal animation for popover menus (plays on mount, since they render
   conditionally). */
@keyframes menuReveal {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.dropdown-header {
  padding: 10px 12px 12px;
}

.dropdown-name {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
}

.dropdown-role {
  font-size: 13px;
  color: var(--text-sub);
  margin-top: 2px;
}

.dropdown-email {
  font-size: 13px;
  color: var(--muted);
  margin-top: 2px;
  word-break: break-all;
}

.dropdown-divider {
  height: 1px;
  background: var(--border);
  margin: 4px 0;
}

.dropdown-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 9px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text);
  transition: background 0.12s;
}

.dropdown-item:hover {
  background: var(--surface-2);
}

.dropdown-item.danger {
  color: #dc2626;
}

.dropdown-item.danger:hover {
  background: #fef2f2;
}

.page {
  padding: 24px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.page-subtitle {
  margin: 4px 0 0;
  color: var(--text-sub);
  font-size: 14px;
}

/* ---------- Segment cards ---------- */
.segment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.segment-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  text-decoration: none;
  color: inherit;
  transition: border-color 0.15s, transform 0.05s;
}

.segment-card:hover {
  border-color: var(--primary);
}

.segment-card:active {
  transform: translateY(1px);
}

.segment-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: var(--primary-tint);
  color: var(--primary);
  display: grid;
  place-items: center;
  flex: none;
}

.segment-icon svg {
  width: 24px;
  height: 24px;
}

.segment-body {
  flex: 1;
}

.segment-count {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.segment-label {
  font-size: 13px;
  color: var(--text-sub);
}

.segment-arrow {
  color: var(--muted);
  font-size: 18px;
}

/* ---------- Placeholder ---------- */
.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 64px 24px;
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  background: var(--surface-2);
}

.placeholder-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  display: grid;
  place-items: center;
  color: var(--primary);
}

.placeholder-icon svg {
  width: 26px;
  height: 26px;
}

.placeholder h2 {
  margin: 0;
  font-size: 18px;
}

.placeholder p {
  margin: 0;
  max-width: 380px;
  color: var(--text-sub);
  font-size: 14px;
  line-height: 1.5;
}

/* ---------- Charts (Performance pages) ---------- */
.chart-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 20px;
  margin-bottom: 20px;
}

.chart-card-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px;
}

.chart-card-sub {
  font-size: 12.5px;
  color: var(--text-sub);
  margin: 0 0 16px;
}

.chart-wrap {
  position: relative;
}

.chart-svg {
  width: 100%;
  height: auto;
  display: block;
}

.chart-grid {
  stroke: var(--border);
  stroke-width: 1;
  stroke-dasharray: 3 3;
}

.chart-axis {
  stroke: var(--border);
  stroke-width: 1;
}

.chart-grid-label,
.chart-x-label {
  font-size: 10px;
  fill: var(--muted);
}

.chart-bar {
  fill: var(--primary);
  transition: opacity 0.1s ease;
}

.chart-bar.hovered {
  fill: var(--primary-dark);
}

.chart-tooltip {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  background: var(--text);
  color: #fff;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  pointer-events: none;
  white-space: nowrap;
  z-index: 5;
}

.chart-tooltip-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
}

.chart-tooltip-value {
  font-weight: 600;
}

.hbar-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.hbar-row {
  display: grid;
  grid-template-columns: 220px 1fr 64px;
  align-items: center;
  gap: 12px;
}

.hbar-label {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hbar-sub {
  color: var(--text-sub);
  font-weight: 400;
  margin-left: 6px;
  font-size: 12px;
}

.hbar-track {
  background: var(--surface-2);
  border-radius: 4px;
  height: 14px;
  overflow: hidden;
}

.hbar-fill {
  height: 100%;
  border-radius: 4px;
  min-width: 3px;
}

.hbar-value {
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
  text-align: right;
  color: var(--text-sub);
}

.funnel-steps {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.funnel-conversion {
  font-size: 11.5px;
  color: var(--muted);
  padding-left: 232px;
}

@media (max-width: 720px) {
  .hbar-row {
    grid-template-columns: 120px 1fr 56px;
  }

  .funnel-conversion {
    padding-left: 132px;
  }
}

/* ---------- Settings & integrations ---------- */
.settings-grid {
  display: grid;
  gap: 20px;
  max-width: 760px;
}

.settings-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 20px;
}

.settings-card-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 2px;
}

.settings-card-sub {
  font-size: 12.5px;
  color: var(--text-sub);
  margin: 0 0 16px;
}

.settings-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-top: 1px solid var(--border);
  font-size: 13.5px;
}

.settings-row:first-of-type {
  border-top: 0;
}

.settings-row-label {
  color: var(--text-sub);
}

.integration-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.integration-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--primary-tint);
  color: var(--primary-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.integration-meta {
  flex: 1;
  min-width: 0;
}

.integration-name {
  font-weight: 600;
  font-size: 14px;
}

.integration-sub {
  font-size: 12.5px;
  color: var(--text-sub);
}

.integration-note {
  background: var(--surface-2);
  border: 1px dashed var(--border);
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 12.5px;
  color: var(--text-sub);
  line-height: 1.5;
}

.integration-note code {
  font-size: 11.5px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 1px 5px;
}

/* ---------- Inbox ---------- */
.inbox-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.inbox-address {
  font-size: 12.5px;
  color: var(--text-sub);
  margin-left: auto;
}

.mail-row td {
  vertical-align: top;
}

.mail-from {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.mail-subject {
  font-weight: 500;
}

.mail-snippet {
  color: var(--text-sub);
  font-size: 12.5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mail-unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--primary);
  margin-right: 8px;
}

.placeholder-tag {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--primary-dark);
  background: var(--primary-tint);
  border: 1px solid #bfdbfe;
  padding: 3px 10px;
  border-radius: 999px;
}

/* ---------- Responsive ---------- */
@media (max-width: 860px) {
  .sidebar {
    width: 220px;
  }
}

@media (max-width: 720px) {
  .kpi-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .segment-grid {
    grid-template-columns: 1fr;
  }
}

/* ---------- Dark theme ----------
   Variables flip on <html data-theme="dark"> (set by ThemeProvider), plus
   targeted overrides for the components that use hardcoded light-mode colors
   (sidebar, badges, notes). */
:root[data-theme='dark'] {
  /* Dark-render native form controls so unchecked checkboxes / select popups
     aren't glowing white against the dark UI. */
  color-scheme: dark;
  /* Neutral (unsaturated) greys — no blue cast. Brand accent (--primary)
     stays blue since it's the shared brand colour in both themes. */
  --bg: #0a0a0a;
  --surface: #242424;
  --surface-2: #151515;
  --border: #333333;
  --table-line: rgba(255, 255, 255, 0.09);
  --text: #f5f5f5;
  --text-sub: #a3a3a3;
  --muted: #737373;
  --primary: #3C87F7;
  --primary-dark: #7FB0FA;
  --primary-tint: rgba(60, 135, 247, 0.16);
  --shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3);
  --map-base: #1f1f1f;
  --map-accent: #3C87F7;
  --map-null: #171717;
  --map-stroke: #0a0a0a;
  --topbar-bg: rgba(21, 21, 21, 0.85);
  --scrollbar-thumb: rgba(255, 255, 255, 0.13);
  --scrollbar-thumb-hover: rgba(255, 255, 255, 0.26);
}

:root[data-theme='dark'] .sidebar {
  background: #0d0d0d;
  border-right-color: #242424;
}

:root[data-theme='dark'] .sidebar-footer {
  background: #0d0d0d;
  border-top-color: #242424;
}

:root[data-theme='dark'] .workspace-switch:hover {
  background: #242424;
  color: var(--text);
}

:root[data-theme='dark'] .nav-item.active {
  background: #242424;
}

:root[data-theme='dark'] .nav-parent.active-parent,
:root[data-theme='dark'] .nav-subitem.active {
  color: #f5f5f5;
}

:root[data-theme='dark'] .nav-submenu::before {
  background: #333333;
}

:root[data-theme='dark'] .nav-subitem.active::before {
  background: #f5f5f5;
}

:root[data-theme='dark'] .nav-subitem:hover {
  background: #242424;
  color: #e5e5e5;
}

:root[data-theme='dark'] .login-error {
  background: rgba(220, 38, 38, 0.15);
  color: #fca5a5;
  border-color: rgba(220, 38, 38, 0.4);
}

:root[data-theme='dark'] .enrich-bar {
  background: rgba(60, 135, 247, 0.12);
  border-color: rgba(60, 135, 247, 0.35);
}

:root[data-theme='dark'] .enrich-status {
  background: rgba(34, 197, 94, 0.12);
  border-color: rgba(34, 197, 94, 0.35);
  color: #4ade80;
}

:root[data-theme='dark'] .badge-enriched {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

:root[data-theme='dark'] .badge-new {
  background: rgba(59, 130, 246, 0.16);
  color: #93c5fd;
}

:root[data-theme='dark'] .badge-contacted {
  background: rgba(139, 92, 246, 0.16);
  color: #c4b5fd;
}

:root[data-theme='dark'] .badge-quoted {
  background: rgba(234, 179, 8, 0.16);
  color: #fde047;
}

:root[data-theme='dark'] .badge-scheduled {
  background: rgba(6, 182, 212, 0.16);
  color: #67e8f9;
}

:root[data-theme='dark'] .badge-won {
  background: rgba(34, 197, 94, 0.16);
  color: #4ade80;
}

:root[data-theme='dark'] .badge-lost {
  background: rgba(220, 38, 38, 0.16);
  color: #fca5a5;
}

:root[data-theme='dark'] .chip-auto {
  background: rgba(60, 135, 247, 0.14);
  border-color: rgba(60, 135, 247, 0.35);
}

:root[data-theme='dark'] .leads-table tbody tr.selected {
  background: rgba(60, 135, 247, 0.1);
}

:root[data-theme='dark'] .leads-table tbody tr.selected:hover {
  background: rgba(60, 135, 247, 0.16);
}

/* Tooltip keeps its own fixed dark chrome in both themes. */
.chart-tooltip {
  background: #151515;
  color: #fafafa;
  border: 1px solid #333333;
}

/* ---------- Assistant drawer ---------- */
.assistant-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.35);
  z-index: 40;
  opacity: 0;
  animation: assistant-fade 0.2s ease forwards;
}

@keyframes assistant-fade {
  to {
    opacity: 1;
  }
}

/* Chart marks rise from the baseline on mount (transform-box:fill-box +
   transform-origin:bottom put the scale origin on the axis, not the viewBox). */
@keyframes barGrow {
  from {
    transform: scaleY(0);
  }
  to {
    transform: scaleY(1);
  }
}

/* Dashboard tab panels: cross-fade in instead of snapping. */
@keyframes tabIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Indeterminate progress bar (AI sequence discovery). */
@keyframes seqbar {
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(320%);
  }
}

/* Toast slide-in (ToastHost, bottom-right). */
@keyframes toastIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.assistant-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: min(380px, 92vw);
  background: var(--surface);
  border-left: 1px solid var(--border);
  box-shadow: -8px 0 30px rgba(2, 6, 23, 0.18);
  z-index: 41;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0.24, 1);
}

.assistant-panel.open {
  transform: translateX(0);
}

.assistant-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--border);
}

.assistant-head-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--primary-tint);
  color: var(--primary-dark);
  display: flex;
  align-items: center;
  justify-content: center;
}

.assistant-title {
  font-weight: 600;
  font-size: 14px;
}

.assistant-sub {
  font-size: 11.5px;
  color: var(--text-sub);
}

.assistant-close {
  margin-left: auto;
}

.assistant-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.assistant-msg {
  max-width: 88%;
  border-radius: 12px;
  padding: 9px 12px;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.assistant-msg.from-user {
  align-self: flex-end;
  background: var(--primary);
  color: #fff;
  border-bottom-right-radius: 4px;
}

.assistant-msg.from-assistant {
  align-self: flex-start;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-bottom-left-radius: 4px;
}

.assistant-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.assistant-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 16px 10px;
}

.assistant-input-row {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--border);
}

.assistant-input-row input {
  flex: 1;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 9px 12px;
  font-size: 13px;
  background: var(--surface);
  color: var(--text);
}

.assistant-input-row input:focus {
  outline: none;
  border-color: var(--primary);
}

/* ---------- Notifications dropdown ---------- */
.notif-menu {
  position: relative;
}

.notif-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 340px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: 0 12px 32px rgba(2, 6, 23, 0.16);
  z-index: 30;
  overflow: hidden;
  transform-origin: top right;
  animation: menuReveal 0.16s ease;
}

.notif-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  font-weight: 600;
  font-size: 13px;
}

.notif-mark {
  font-size: 12px;
  color: var(--primary-dark);
  background: none;
  border: none;
  padding: 0;
}

.notif-list {
  max-height: 340px;
  overflow-y: auto;
}

.notif-item {
  display: flex;
  gap: 10px;
  padding: 11px 14px;
  border-bottom: 1px solid var(--border);
  font-size: 12.5px;
  align-items: flex-start;
}

.notif-item:last-child {
  border-bottom: 0;
}

.notif-item.unread {
  background: var(--primary-tint);
}

.notif-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--primary);
  margin-top: 5px;
  flex-shrink: 0;
}

.notif-dot.read {
  background: var(--border);
}

.notif-text {
  flex: 1;
  min-width: 0;
}

.notif-label {
  font-weight: 600;
}

.notif-detail {
  color: var(--text-sub);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notif-time {
  color: var(--muted);
  font-size: 11.5px;
  white-space: nowrap;
}

.notif-empty {
  padding: 22px 14px;
  text-align: center;
  color: var(--text-sub);
  font-size: 12.5px;
}

.notif-footer {
  border-top: 1px solid var(--border);
  padding: 9px 14px;
  text-align: center;
}

/* ---------- MultiStepForm wizard ---------- */
.logo-mark-sm {
  width: 26px;
  height: 26px;
  font-size: 13px;
  border-radius: 7px;
}

.msf {
  display: flex;
  min-height: 100vh;
  background: var(--surface);
  color: var(--text);
}

/* Wizard content area (sidebar stays; wizard fills the rest, no Topbar/padding). */
.main-flush {
  padding: 0;
}

/* When a wizard renders inside the app layout, fill the available space beside
   the sidebar instead of forcing a second full-viewport-height scroll region. */
.main-flush .msf {
  flex: 1;
  min-height: 0;
}

.msf-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px 7px 9px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-sub);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.msf-back:hover {
  background: var(--surface-2);
  color: var(--text);
  border-color: var(--text-sub);
}

.msf-back svg {
  width: 16px;
  height: 16px;
}

/* Left visual panel */
.msf-aside {
  flex: 1 1 50%;
  position: relative;
  overflow: hidden;
  background: var(--surface-2);
  border-right: 1px solid var(--border);
}

.msf-stage {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  padding-left: 7%;
  perspective: 1800px;
  overflow: hidden;
}

.msf-preview-card {
  width: 132%;
  transform: rotateY(24deg) rotateX(6deg) rotateZ(-3deg);
  transform-origin: left center;
  filter: drop-shadow(0 30px 60px rgba(2, 6, 23, 0.14));
}

/* Right form panel */
.msf-main {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  padding: 26px 44px 30px;
  min-width: 0;
}

.msf-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.msf-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--text);
  color: var(--surface);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.msf-progress {
  display: flex;
  gap: 7px;
  width: 210px;
  margin: 10px auto 0;
}

.msf-progress-seg {
  flex: 1;
  height: 4px;
  border-radius: 2px;
  background: var(--border);
  transition: background 0.2s ease;
}

.msf-progress-seg.filled {
  background: var(--text);
}

.msf-scroll {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
  padding: 32px 0;
}

.msf-body {
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
}

.msf-title {
  font-size: 27px;
  font-weight: 600;
  letter-spacing: -0.01em;
  margin: 0 0 14px;
}

.msf-desc {
  font-size: 14px;
  line-height: 1.55;
  color: var(--text-sub);
  margin: 0;
  max-width: 54ch;
}

.msf-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 22px;
  margin-top: 30px;
}

.msf-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.msf-field.full,
.msf-help,
.msf-divider {
  grid-column: 1 / -1;
}

.msf-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
}

.msf-input,
.msf-select {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface-2);
  font-size: 14px;
  color: var(--text);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.msf-input::-moz-placeholder {
  color: var(--muted);
}

.msf-input::placeholder {
  color: var(--muted);
}

.msf-input:focus,
.msf-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);
}

.msf-textarea {
  resize: vertical;
  min-height: 96px;
  font-family: inherit;
  line-height: 1.5;
}

.msf-select-wrap {
  position: relative;
}

.msf-select {
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  padding-right: 38px;
  cursor: pointer;
}

.msf-select-caret {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: var(--muted);
  pointer-events: none;
}

.msf-help {
  font-size: 12.5px;
  color: var(--text-sub);
  margin: 0;
  line-height: 1.5;
}

.msf-divider {
  height: 1px;
  background: var(--border);
  margin: 6px 0;
}

.msf-error {
  font-size: 12px;
  color: #dc2626;
}

.msf-field.error .msf-input,
.msf-field.error .msf-select {
  border-color: #dc2626;
}

.msf-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding-top: 16px;
}

.msf-continue {
  min-width: 120px;
  justify-content: center;
}

/* Aside mock content (dashboard / sequence previews) */
.mock {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: var(--shadow);
  padding: 22px;
  width: 640px;
  max-width: 100%;
}

.mock-eyebrow {
  font-size: 12px;
  color: var(--text-sub);
  margin-bottom: 6px;
}

.mock-greet {
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.mock-sub {
  font-size: 13px;
  color: var(--text-sub);
  margin-top: 4px;
  margin-bottom: 18px;
}

.mock-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.mock-tile {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px;
  background: var(--surface-2);
}

.mock-tile-label {
  font-size: 11px;
  color: var(--text-sub);
}

.mock-tile-val {
  font-size: 20px;
  font-weight: 700;
  margin-top: 6px;
}

.mock-bars {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 34px;
  margin-top: 10px;
}

.mock-bars span {
  flex: 1;
  background: var(--primary);
  border-radius: 2px 2px 0 0;
  opacity: 0.85;
}

.mock-seq-step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--border);
  font-size: 14px;
}

.mock-seq-step:first-of-type {
  border-top: 0;
}

.mock-seq-day {
  font-size: 11px;
  font-weight: 700;
  color: var(--primary-dark);
  background: var(--primary-tint);
  border-radius: 999px;
  padding: 3px 10px;
  white-space: nowrap;
}

/* Dark-mode: keep the aside footer dark (it already is) and soften the stage */
:root[data-theme='dark'] .msf-preview-card {
  filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.5));
}

@media (max-width: 900px) {
  .msf-aside {
    display: none;
  }
  .msf-main {
    flex-basis: 100%;
    padding: 24px 24px 28px;
  }
  .msf-fields {
    grid-template-columns: 1fr;
  }
  .msf-field.half {
    grid-column: 1 / -1;
  }
}

/* Honor reduced-motion: keep everything functional but instant. */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}

/* Conversation-title marquee on the chat history panel: on hover the title
   scrolls to reveal its full text (distance fed in as --marq) and back. Only
   overflowing titles set --marq, so short ones don't move. */
@keyframes marqueeTitle {
  0%, 12% { transform: translateX(0); }
  88%, 100% { transform: translateX(var(--marq, 0px)); }
}

/* ---------- Agent run flowchart (components/FlowCanvas.jsx) ----------
   The gridded canvas the run is drawn on, plus the two motions that make the
   graph legible: dashes marching along a LIVE edge (an edge whose target node
   is running) and a ring breathing around the running card.

   Every colour is a variable with a dark-theme counterpart. A hardcoded grid
   colour is invisible in one theme or blinding in the other, and this block is
   appended after the main :root[data-theme='dark'] block on purpose so the
   dark values win by source order at equal specificity. */
:root {
  --flow-dot: rgba(15, 23, 42, 0.12);
  --flow-rule: rgba(15, 23, 42, 0.035);
  --flow-edge: #cbd5e1;
  --flow-edge-muted: rgba(148, 163, 184, 0.75);
}

:root[data-theme='dark'] {
  --flow-dot: rgba(255, 255, 255, 0.11);
  --flow-rule: rgba(255, 255, 255, 0.03);
  --flow-edge: #3f3f3f;
  --flow-edge-muted: rgba(115, 115, 115, 0.8);
}

/* Two layers: a coarse 96px rule for structure and a 24px dot field for
   texture. background-attachment:local ties the grid to the scrolled content,
   so panning the flow moves the paper with it rather than sliding the nodes
   over a fixed backdrop. */
.flow-grid {
  background-color: var(--surface);
  background-image:
    linear-gradient(to right, var(--flow-rule) 1px, transparent 1px),
    linear-gradient(to bottom, var(--flow-rule) 1px, transparent 1px),
    radial-gradient(circle at center, var(--flow-dot) 1.05px, transparent 1.15px);
  background-size: 96px 96px, 96px 96px, 24px 24px;
  background-position: 0 0, 0 0, 12px 12px;
  background-attachment: local, local, local;
}

@keyframes flowMarch {
  to {
    stroke-dashoffset: -32;
  }
}

.flow-edge-live {
  animation: flowMarch 0.9s linear infinite;
}

@keyframes flowBreathe {
  0%,
  100% {
    opacity: 0.16;
  }
  50% {
    opacity: 0.6;
  }
}

.flow-pulse {
  opacity: 0.16;
  animation: flowBreathe 1.6s cubic-bezier(0.32, 0.72, 0.24, 1) infinite;
}

/* Reduced motion: the global rule near the top of this file already collapses
   every animation to ~0ms, which would freeze the marching dashes MID-GAP and
   leave a live edge looking like a broken one. So the dashes are removed
   outright (a live edge stays a solid, heavier, primary-coloured wire) and the
   breathing ring settles at a readable steady opacity. Nothing moves; nothing
   loses its meaning. */
@media (prefers-reduced-motion: reduce) {
  .flow-edge-live {
    animation: none;
    stroke-dasharray: none;
    stroke: none;
  }
  .flow-pulse {
    animation: none;
    opacity: 0.5;
  }
}

/* ---------- Draft narrative (components/DraftFlowView.jsx, "Main" view) ----
   Each big sentence enters like marketing copy: blurred, low, transparent,
   then settling. Stagger comes from an inline animation-delay per line, and
   fill-mode 'both' holds the hidden from-state through that delay.

   .narrative-line starts hidden so a section below the fold has nothing to
   flash before its IntersectionObserver fires; .narrative-line-in is added by
   the component when the section scrolls into view (once). */
@keyframes narrativeLineIn {
  from {
    opacity: 0;
    filter: blur(14px);
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0);
  }
}

.narrative-line {
  opacity: 0;
}

.narrative-line-in {
  animation: narrativeLineIn 700ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* Reduced motion: everything simply visible — no entrance, no blur, no
   translate. The component also skips its observer and delays, but the CSS
   guarantees it even if a line never gets the -in class. */
@media (prefers-reduced-motion: reduce) {
  .narrative-line {
    opacity: 1;
  }
  .narrative-line-in {
    animation: none;
    filter: none;
    transform: none;
  }
}

/* Activity → detail page: the rows behind a number slide in from the right and
   back out again, so the tiles and their evidence read as two places rather
   than one long scroll. A keyframe rather than a class-toggled transform: the
   toggle depends on the element being painted off-screen for one frame first,
   which a background tab (rAF throttled) collapses into a jump. */
@keyframes detailIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes detailOut {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

/* The summary steps aside under the incoming page, giving the two views a
   spatial relationship instead of a cut. */
@keyframes summaryAside {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-32px);
    opacity: 0;
  }
}

@keyframes summaryBack {
  from {
    transform: translateX(-32px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.detail-enter {
  animation: detailIn 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;
}

.detail-exit {
  animation: detailOut 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;
}

.summary-aside {
  animation: summaryAside 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;
}

.summary-back {
  animation: summaryBack 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;
}

@media (prefers-reduced-motion: reduce) {
  .detail-enter,
  .detail-exit,
  .summary-aside,
  .summary-back {
    animation-duration: 1ms;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,uEAAuE;EACvE,mBAAmB;EACnB,kEAAkE;EAClE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,0EAA0E;EAC1E,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,4EAA4E;EAC5E,cAAc;EACd;uEACqE;EACrE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;4DAI4D;AAC5D;;EAEE,wBAAwB;AAC1B;AACA,YAAY;AACZ;EACE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB;sCACoC;EACpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;;;sCAGsC;AACtC;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;EACE,aAAa,EAAE,+BAA+B;AAChD;;AAEA;;;;;;2DAM2D;AAC3D;;;;;;EAME,oCAAoC;EACpC,wBAAwB;EAExB,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;;EAEE,oCAAoC;EACpC,wBAAwB;EAExB,gFAAgF;AAClF;;AAEA;4DAC4D;AAC5D;;;;EAIE,gCAAgC;EAChC,oBAAoB;EAEpB,sCAAsC;AACxC;;AAEA;+BAC+B;AAC/B;;;EAIE,+CAA+C;AACjD;AACA;EAEE,kFAAkF;AACpF;;AAEA;;;EAGE,SAAS;EACT,YAAY;AACd;;AAEA;EACE;qBACmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;;;EAGE,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wEAAwE;EACxE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yEAAyE;AAC3E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2DAA2D;EAC3D,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;;oCAEkC;EAClC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;gEAEgE;AAChE;EACE,WAAW;AACb;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;+EAC+E;AAC/E;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wEAAwE;EACxE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP;mFACiF;EACjF,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,2DAA2D;EAC3D,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa,EAAE,kBAAkB;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;+DAC+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB;gDAC8C;EAC9C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;;EAEE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,mCAAmC;EACnC,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,4DAA4D;AAC5D;EACE;IACE,aAAa;EACf;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;mEAEmE;AACnE;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA;oBACoB;AACpB;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;8BAG8B;AAC9B;EACE;gDAC8C;EAC9C,kBAAkB;EAClB;oEACkE;EAClE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,oEAAoE;EACpE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;gFACgF;AAChF;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,4CAA4C;EAC5C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4CAA4C;EAC5C,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,mFAAmF;AACnF;EACE,UAAU;AACZ;;AAEA;gFACgF;AAChF;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sDAAsD;EACtD,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAgB;OAAhB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,mDAAmD;AACrD;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,kEAAkE;AAClE;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;EACzC;AACF;;AAEA;;6DAE6D;AAC7D;EACE,UAAU,wBAAwB,EAAE;EACpC,YAAY,uCAAuC,EAAE;AACvD;;AAEA;;;;;;;;0DAQ0D;AAC1D;EACE,kCAAkC;EAClC,oCAAoC;EACpC,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;;;2BAG2B;AAC3B;EACE,gCAAgC;EAChC;;;iFAG+E;EAC/E,gDAAgD;EAChD,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sEAAsE;AACxE;;AAEA;;;;;uBAKuB;AACvB;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;;;;;;6DAO6D;AAC7D;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oEAAoE;AACtE;;AAEA;;2DAE2D;AAC3D;EACE;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;;;kEAIkE;AAClE;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;2CAC2C;AAC3C;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE;;;;IAIE,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  /* Light-render native form controls (checkboxes, selects, spinners). */\n  color-scheme: light;\n  /* Dark auth-hero base (login/signup radial). Neutral, not navy. */\n  --bg: #0a0a0a;\n  --surface: #ffffff;\n  --surface-2: #f8fafc;\n  --border: #e2e8f0;\n  /* Fainter line used only for in-table grid rules (row/column dividers). */\n  --table-line: rgba(15, 23, 42, 0.06);\n  --text: #0f172a;\n  --text-sub: #64748b;\n  --muted: #94a3b8;\n  --primary: #3C87F7;\n  --primary-dark: #1D68D9;\n  --primary-tint: #eaf2fe;\n  --shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);\n  --radius: 12px;\n  /* Market Map choropleth: brand-blue sequential ramp (base → accent), a\n     neutral fill for states with no data, and a state-border stroke. */\n  --map-base: #e6f0fe;\n  --map-accent: #1D68D9;\n  --map-null: #eef1f5;\n  --map-stroke: #ffffff;\n  --topbar-bg: rgba(255, 255, 255, 0.85);\n  --scrollbar-thumb: rgba(100, 116, 139, 0.14);\n  --scrollbar-thumb-hover: rgba(100, 116, 139, 0.28);\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* ---------- No focus outline, site-wide ----------\n   Removes the browser's default focus ring on every focusable element\n   (buttons, links, nav items, section toggles, etc.) whether reached by\n   click or by keyboard Tab. Applies to both :focus and :focus-visible so\n   nothing shows a stock blue outline anywhere on the app. */\n*:focus,\n*:focus-visible {\n  outline: none !important;\n}\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) transparent;\n}\n\n/* WebKit / Chromium / Safari */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track,\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 999px;\n  /* Transparent border + padding-box clip keeps the visible thumb slim\n     and inset from the track edges. */\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n  background-clip: padding-box;\n}\n\n/* ---------- Hidden scrollbar ----------\n   The container still scrolls (wheel, trackpad, keys, touch) but draws no bar.\n   Used ONLY on the Main story view's scroll container in DraftFlowView — a\n   reading surface, not a workbench. */\n.no-scrollbar {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* legacy Edge/IE */\n}\n\n.no-scrollbar::-webkit-scrollbar {\n  display: none; /* WebKit / Chromium / Safari */\n}\n\n/* ---------- Autofilled fields ----------\n   Browsers force their own light background (Chrome uses rgb(232, 240, 254))\n   and text colour onto autofilled inputs, which breaks the theme — the field\n   flashes light even in dark mode. The background can't be overridden directly\n   on :-webkit-autofill, so we paint over it with a large inset box-shadow in\n   the field's own colour and force the text fill colour. Driven by theme\n   variables, so it stays correct in both light and dark. */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:active,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:active {\n  -webkit-text-fill-color: var(--text);\n  caret-color: var(--text);\n  -webkit-box-shadow: 0 0 0 1000px var(--surface) inset;\n  box-shadow: 0 0 0 1000px var(--surface) inset;\n}\n\n/* Keep the focus ring on top of the autofill fill. */\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--text);\n  caret-color: var(--text);\n  -webkit-box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2), 0 0 0 1000px var(--surface) inset;\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2), 0 0 0 1000px var(--surface) inset;\n}\n\n/* Auth pages are always dark regardless of theme — autofill must fill the\n   pill's own dark color, not the light theme's --surface. */\n.auth-dark input:-webkit-autofill,\n.auth-dark input:-webkit-autofill:hover,\n.auth-dark input:-webkit-autofill:focus,\n.auth-dark input:-webkit-autofill:active {\n  -webkit-text-fill-color: #f5f5f5;\n  caret-color: #f5f5f5;\n  -webkit-box-shadow: 0 0 0 1000px #1b1b1b inset;\n  box-shadow: 0 0 0 1000px #1b1b1b inset;\n}\n\n/* MultiStepForm fields sit on --surface-2 (bg-panel), so match\n   that instead of --surface. */\n[id^='msf-']:-webkit-autofill,\n[id^='msf-']:-webkit-autofill:hover,\n[id^='msf-']:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px var(--surface-2) inset;\n  box-shadow: 0 0 0 1000px var(--surface-2) inset;\n}\n[id^='msf-']:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2), 0 0 0 1000px var(--surface-2) inset;\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2), 0 0 0 1000px var(--surface-2) inset;\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  height: 100%;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,\n    Arial, sans-serif;\n  color: var(--text);\n  background: var(--surface-2);\n  -webkit-font-smoothing: antialiased;\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n}\n\n/* Native inputs default to UA fonts (textarea: monospace) — use the app font. */\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n}\n\n/* ---------- Brand ---------- */\n.logo-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n  flex: none;\n}\n\n.brand-name {\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1.2;\n}\n\n.brand-sub {\n  font-size: 12px;\n  color: var(--text-sub);\n}\n\n/* ---------- Login ---------- */\n.login-shell {\n  min-height: 100%;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: radial-gradient(1200px 600px at 50% -10%, #242424, var(--bg));\n}\n\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  background: var(--surface);\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 20px 50px rgba(2, 6, 23, 0.45);\n}\n\n.login-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.login-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-sub);\n}\n\n.login-form input {\n  padding: 11px 13px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  font-size: 15px;\n  color: var(--text);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n.login-error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n  padding: 9px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.login-hint {\n  margin-top: 18px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.login-link {\n  color: var(--primary-dark);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.login-link:hover {\n  text-decoration: underline;\n}\n\n/* ---------- Buttons ---------- */\n.btn-primary {\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  padding: 11px 18px;\n  border-radius: 9px;\n  font-size: 15px;\n  font-weight: 600;\n  transition: background 0.15s;\n}\n\n.btn-primary:hover {\n  background: var(--primary-dark);\n}\n\n.btn-full {\n  width: 100%;\n}\n\n.btn-ghost {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-sub);\n  padding: 7px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: background 0.15s, color 0.15s;\n}\n\n.btn-ghost:hover {\n  background: var(--surface-2);\n  color: var(--text);\n}\n\n/* ---------- App shell ---------- */\n.app-shell {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 24px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.topbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.topbar-user {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.user-name {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.content {\n  padding: 24px;\n  max-width: 1400px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* ---------- KPI ---------- */\n.kpi-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.kpi-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 18px 20px;\n  box-shadow: var(--shadow);\n}\n\n.kpi-value {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.kpi-label {\n  font-size: 13px;\n  color: var(--text-sub);\n  margin-top: 4px;\n}\n\n/* ---------- Controls ---------- */\n.controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.search {\n  flex: 1;\n  min-width: 240px;\n  padding: 10px 14px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  font-size: 14px;\n  background: var(--surface);\n}\n\n.search:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n.status-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  background: var(--surface);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-sub);\n  transition: all 0.15s;\n}\n\n.chip:hover {\n  border-color: var(--muted);\n}\n\n.chip-active {\n  background: var(--primary-tint);\n  border-color: var(--primary);\n  color: var(--primary-dark);\n}\n\n.chip-count {\n  background: var(--surface-2);\n  border-radius: 999px;\n  padding: 1px 8px;\n  font-size: 11px;\n  color: var(--text-sub);\n}\n\n.chip-active .chip-count {\n  background: #dbeafe;\n  color: var(--primary-dark);\n}\n\n.results-meta {\n  font-size: 13px;\n  color: var(--text-sub);\n  margin-bottom: 12px;\n}\n\n/* ---------- Region select ---------- */\n.region-select {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-sub);\n}\n\n.region-select select {\n  padding: 9px 12px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  background: var(--surface);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text);\n  min-width: 260px;\n  cursor: pointer;\n}\n\n.region-select select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n/* ---------- Row selection + enrich ---------- */\n.enrich-bar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 16px;\n  margin-bottom: 12px;\n  background: var(--primary-tint);\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n}\n\n.enrich-count {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--primary-dark);\n}\n\n.enrich-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-sm {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  font-size: 13px;\n}\n\n.btn-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.enrich-status {\n  display: inline-block;\n  margin-bottom: 12px;\n  padding: 8px 14px;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #15803d;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.leads-table th.check,\n.leads-table td.check {\n  width: 44px;\n  text-align: center;\n  padding-left: 14px;\n  padding-right: 0;\n}\n\n.leads-table td.check input,\n.leads-table th.check input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--primary);\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.leads-table tbody tr.selected {\n  background: var(--primary-tint);\n}\n\n.leads-table tbody tr.selected:hover {\n  background: #dbeafe;\n}\n\n.badge-enriched {\n  display: inline-block;\n  margin: 2px 0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n/* ---------- Company table extras ---------- */\n.company-table {\n  min-width: 1100px;\n}\n\n.cell-link {\n  display: inline-block;\n  font-size: 12.5px;\n  color: var(--primary-dark);\n  text-decoration: none;\n  margin-top: 2px;\n}\n\n.cell-link:hover {\n  text-decoration: underline;\n}\n\n.trade-cell {\n  display: inline-block;\n  max-width: 260px;\n}\n\n.tag {\n  display: inline-block;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 2px 7px;\n  font-size: 11.5px;\n  color: var(--text-sub);\n  margin: 0 4px 4px 0;\n  white-space: nowrap;\n}\n\n.tag-more {\n  display: inline-block;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n/* ---------- Pagination ---------- */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n}\n\n.pagination-info {\n  font-size: 13px;\n  color: var(--text-sub);\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pagination-page {\n  font-size: 13px;\n  color: var(--text-sub);\n  min-width: 110px;\n  text-align: center;\n}\n\n.btn-ghost:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ---------- Clickable table rows ---------- */\n.leads-table tbody tr.row-link {\n  cursor: pointer;\n}\n\n/* ---------- Sequence builder ---------- */\n.builder-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.name-input {\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  border: 1px solid var(--primary);\n  border-radius: 8px;\n  padding: 4px 10px;\n  width: min(520px, 100%);\n}\n\n.page-title .title-edit {\n  width: 16px;\n  height: 16px;\n  color: var(--muted);\n  opacity: 0;\n  vertical-align: middle;\n  transition: opacity 0.12s;\n}\n\n.page-title:hover .title-edit {\n  opacity: 1;\n}\n\n.seq-timeline {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  max-width: 720px;\n}\n\n.seq-wait {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  margin: 8px 0 8px 34px;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-sub);\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n}\n\n.seq-wait-icon {\n  width: 13px;\n  height: 13px;\n}\n\n.seq-step {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 14px 16px;\n  box-shadow: var(--shadow);\n}\n\n.seq-step-day {\n  flex: none;\n  width: 52px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-sub);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.seq-step-icon {\n  flex: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--primary-tint);\n  color: var(--primary);\n  display: grid;\n  place-items: center;\n}\n\n.seq-step-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.seq-step-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.seq-step-type {\n  font-size: 13px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chip-auto {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--primary-dark);\n  background: var(--primary-tint);\n  border-radius: 999px;\n  padding: 1px 7px;\n}\n\n.seq-step-summary {\n  font-size: 13px;\n  color: var(--text-sub);\n  margin-top: 3px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.seq-step-actions {\n  flex: none;\n  display: flex;\n  gap: 4px;\n}\n\n.icon-btn-sm {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  border: none;\n  background: transparent;\n  border-radius: 7px;\n  color: var(--muted);\n}\n\n.icon-btn-sm svg {\n  width: 16px;\n  height: 16px;\n}\n\n.icon-btn-sm:hover {\n  background: var(--surface-2);\n  color: var(--text);\n}\n\n.icon-btn-sm.danger:hover {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.seq-connector {\n  width: 2px;\n  height: 20px;\n  background: var(--border);\n  margin: 4px 0 4px 33px;\n}\n\n.seq-add {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 1px dashed var(--border);\n  border-radius: var(--radius);\n  background: var(--surface);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--primary-dark);\n}\n\n.seq-add:hover {\n  border-color: var(--primary);\n  background: var(--primary-tint);\n}\n\n/* ---------- Modal ---------- */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  z-index: 100;\n}\n\n.modal {\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  overflow-y: auto;\n  background: var(--surface);\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(2, 6, 23, 0.4);\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 17px;\n}\n\n.modal-close {\n  border: none;\n  background: transparent;\n  font-size: 24px;\n  line-height: 1;\n  color: var(--muted);\n  cursor: pointer;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border);\n}\n\n.field-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-sub);\n  margin: 14px 0 6px;\n}\n\n.field-label:first-child {\n  margin-top: 0;\n}\n\n.field-input,\n.field-textarea {\n  width: 100%;\n  padding: 9px 12px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--text);\n}\n\n.field-textarea {\n  resize: vertical;\n}\n\n.field-input:focus,\n.field-textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n.field-hint {\n  font-size: 12px;\n  color: var(--muted);\n  margin-top: 6px;\n}\n\n.field-static {\n  font-size: 13px;\n  color: var(--text-sub);\n  padding: 9px 12px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 9px;\n}\n\n.field-optional {\n  font-weight: 400;\n  color: var(--muted);\n  text-transform: none;\n}\n\n/* AI email drafter inside the Compose modal */\n.draft-assist {\n  margin: 14px 0 4px;\n}\n\n.draft-assist-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.draft-assist-panel {\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 14px;\n  background: var(--surface-2);\n}\n\n.draft-assist-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text);\n  margin-bottom: 4px;\n}\n\n.draft-assist-panel .field-label:first-child {\n  margin-top: 8px;\n}\n\n.draft-assist-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.draft-assist-actions .btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.delay-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--text-sub);\n}\n\n.delay-field input {\n  width: 72px;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.steptype-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.steptype {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 12px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text);\n  text-align: left;\n}\n\n.steptype:hover {\n  border-color: var(--muted);\n}\n\n.steptype.selected {\n  border-color: var(--primary);\n  background: var(--primary-tint);\n  color: var(--primary-dark);\n  font-weight: 600;\n}\n\n.steptype-icon {\n  width: 18px;\n  height: 18px;\n  flex: none;\n}\n\n/* ---------- Collaboration / invite ---------- */\n.invite-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 18px 20px;\n  box-shadow: var(--shadow);\n  margin-bottom: 22px;\n}\n\n.invite-card-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.invite-card-icon {\n  width: 22px;\n  height: 22px;\n  color: var(--primary);\n  flex: none;\n}\n\n.invite-card-title {\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.invite-card-sub {\n  font-size: 13px;\n  color: var(--text-sub);\n}\n\n.invite-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.invite-msg {\n  margin-top: 12px;\n}\n\n.member-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.avatar-sm {\n  width: 34px;\n  height: 34px;\n  font-size: 12px;\n}\n\n@media (max-width: 720px) {\n  .invite-form {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---------- Table ---------- */\n.table-wrap {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: auto;\n  box-shadow: var(--shadow);\n}\n\n.leads-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n\n.leads-table thead th {\n  position: sticky;\n  top: 0;\n  background: var(--surface-2);\n  text-align: left;\n  padding: 12px 14px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--text-sub);\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n  user-select: none;\n}\n\n.leads-table th.sortable {\n  cursor: pointer;\n}\n\n.leads-table th.sortable:hover {\n  color: var(--text);\n}\n\n.leads-table th.num,\n.leads-table td.num {\n  text-align: right;\n}\n\n.sort-caret {\n  color: var(--primary);\n  font-size: 10px;\n}\n\n.leads-table tbody td {\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border);\n  vertical-align: top;\n}\n\n.leads-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.leads-table tbody tr:hover {\n  background: var(--surface-2);\n}\n\n.cell-name {\n  font-weight: 600;\n}\n\n.cell-sub {\n  font-size: 12px;\n  color: var(--muted);\n  margin-top: 2px;\n}\n\n.mono {\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12.5px;\n  color: var(--text-sub);\n}\n\n.muted {\n  color: var(--muted);\n}\n\n/* ---------- Badges ---------- */\n.badge {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.badge-new {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n.badge-contacted {\n  background: #f5f3ff;\n  color: #6d28d9;\n}\n.badge-quoted {\n  background: #fefce8;\n  color: #a16207;\n}\n.badge-scheduled {\n  background: #ecfeff;\n  color: #0e7490;\n}\n.badge-won {\n  background: #f0fdf4;\n  color: #15803d;\n}\n.badge-lost {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n/* ---------- DataTable (shared) ---------- */\n.dt {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* Tabs */\n.dt-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  border-bottom: 1px solid var(--border);\n  padding-bottom: 2px;\n}\n\n.dt-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 12px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-sub);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.dt-tab:hover {\n  background: var(--surface-2);\n  color: var(--text);\n}\n\n.dt-tab.is-active {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n  box-shadow: var(--shadow);\n}\n\n.dt-tab-icon {\n  width: 15px;\n  height: 15px;\n  opacity: 0.7;\n}\n\n.dt-tab-count {\n  background: var(--surface-2);\n  border-radius: 999px;\n  padding: 1px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-sub);\n}\n\n.dt-tab.is-active .dt-tab-count {\n  background: var(--primary-tint);\n  color: var(--primary-dark);\n}\n\n/* Toolbar */\n.dt-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dt-toolbar-left,\n.dt-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dt-toolbar-left {\n  flex: 1;\n  min-width: 200px;\n}\n\n.dt-search {\n  position: relative;\n  flex: 1;\n  max-width: 320px;\n  min-width: 180px;\n}\n\n.dt-search-icon {\n  position: absolute;\n  left: 11px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 15px;\n  height: 15px;\n  color: var(--muted);\n  pointer-events: none;\n}\n\n.dt-search input {\n  width: 100%;\n  padding: 9px 12px 9px 33px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  font-size: 14px;\n  background: var(--surface);\n  color: var(--text);\n}\n\n.dt-search input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n.dt-filter {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 12px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  background: var(--surface);\n  color: var(--text);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dt-filter:hover {\n  background: var(--surface-2);\n}\n\n.dt-filter svg {\n  width: 15px;\n  height: 15px;\n  color: var(--text-sub);\n}\n\n.dt-count {\n  background: var(--primary-tint);\n  color: var(--primary-dark);\n  border-radius: 999px;\n  padding: 1px 7px;\n  font-size: 11px;\n}\n\n.dt-linkbtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  color: var(--text-sub);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 8px;\n}\n\n.dt-linkbtn:hover {\n  background: var(--surface-2);\n  color: var(--text);\n}\n\n.dt-linkbtn svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* Table shell */\n.dt-wrap {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  overflow: auto;\n  box-shadow: var(--shadow);\n}\n\n.dt-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n\n.dt-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--surface);\n  text-align: left;\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-sub);\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n  user-select: none;\n}\n\n.dt-th {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.dt-th-icon {\n  width: 15px;\n  height: 15px;\n  opacity: 0.65;\n}\n\n.dt-table th.dt-sortable {\n  cursor: pointer;\n}\n\n.dt-table th.dt-sortable:hover {\n  color: var(--text);\n}\n\n.dt-caret {\n  color: var(--primary);\n  font-size: 9px;\n  width: 9px;\n}\n\n.dt-table th.dt-right,\n.dt-table td.dt-right {\n  text-align: right;\n}\n\n.dt-table th.dt-right .dt-th {\n  flex-direction: row-reverse;\n}\n\n.dt-table th.dt-center,\n.dt-table td.dt-center {\n  text-align: center;\n}\n\n.dt-table tbody td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n  vertical-align: middle;\n  color: var(--text);\n}\n\n.dt-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dt-table tbody tr:hover {\n  background: var(--surface-2);\n}\n\n.dt-table tbody tr.dt-rowlink {\n  cursor: pointer;\n}\n\n.dt-table tbody tr.is-selected {\n  background: var(--primary-tint);\n}\n\n.dt-check {\n  width: 40px;\n  text-align: center;\n  padding-left: 14px !important;\n  padding-right: 0 !important;\n}\n\n.dt-check input {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  accent-color: var(--primary);\n}\n\n.dt-empty-row td {\n  padding: 0 !important;\n}\n\n.dt-empty {\n  padding: 40px;\n  text-align: center;\n  color: var(--text-sub);\n}\n\n/* Status pills (icon + label) */\n.dt-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px 3px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.dt-pill-icon {\n  width: 13px;\n  height: 13px;\n}\n\n.dt-pill-neutral {\n  background: var(--surface-2);\n  color: var(--text-sub);\n}\n.dt-pill-warning {\n  background: #fefce8;\n  color: #a16207;\n}\n.dt-pill-success {\n  background: #f0fdf4;\n  color: #15803d;\n}\n.dt-pill-info {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n.dt-pill-danger {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n.dt-pill-purple {\n  background: #f5f3ff;\n  color: #6d28d9;\n}\n\n/* Pagination */\n.dt-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.dt-pagination-info {\n  font-size: 13px;\n  color: var(--text-sub);\n}\n\n.dt-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dt-pagination-page {\n  font-size: 13px;\n  color: var(--text-sub);\n}\n\n:root[data-theme='dark'] .dt-pill-warning {\n  background: rgba(161, 98, 7, 0.18);\n  color: #fbbf24;\n}\n:root[data-theme='dark'] .dt-pill-success {\n  background: rgba(21, 128, 61, 0.18);\n  color: #4ade80;\n}\n:root[data-theme='dark'] .dt-pill-info {\n  background: rgba(29, 78, 216, 0.2);\n  color: #93bdfb;\n}\n:root[data-theme='dark'] .dt-pill-danger {\n  background: rgba(185, 28, 28, 0.2);\n  color: #fca5a5;\n}\n:root[data-theme='dark'] .dt-pill-purple {\n  background: rgba(109, 40, 217, 0.22);\n  color: #c4b5fd;\n}\n:root[data-theme='dark'] .dt-table tbody tr.is-selected {\n  background: rgba(60, 135, 247, 0.16);\n}\n\n/* ---------- States ---------- */\n.empty-state,\n.error-state {\n  padding: 40px;\n  text-align: center;\n  color: var(--text-sub);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n\n.error-state {\n  color: #b91c1c;\n}\n\n/* ---------- Search results page ---------- */\n.search-page-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  max-width: 560px;\n  margin-bottom: 24px;\n  padding: 11px 15px;\n  border: 1px solid var(--border);\n  border-radius: 11px;\n  background: var(--surface);\n  color: var(--text-sub);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.search-page-bar:focus-within {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n.search-page-bar svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n}\n\n.search-page-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font-size: 15px;\n  color: var(--text);\n  outline: none;\n}\n\n.search-page-input::placeholder {\n  color: var(--muted);\n}\n\n.search-group {\n  margin-bottom: 24px;\n}\n\n.search-group-title {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-sub);\n  margin: 0 0 10px;\n}\n\n.search-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.search-result {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  text-decoration: none;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease;\n}\n\n.search-result:hover {\n  border-color: var(--primary);\n  box-shadow: var(--shadow);\n}\n\n.search-result-main {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.search-result-sub {\n  font-size: 13px;\n  color: var(--text-sub);\n  white-space: nowrap;\n}\n\n/* ---------- App layout ---------- */\n.layout {\n  /* Mirrors the sidebar's current width so viewport-centered chrome (e.g. the\n     topbar search) can offset itself past the sidebar. Kept in sync with the\n     `.sidebar` width rules below. */\n  --sidebar-w: 264px;\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.layout:has(.sidebar.sidebar-collapsed) {\n  --sidebar-w: 68px;\n}\n\n@media (max-width: 860px) {\n  .layout {\n    --sidebar-w: 220px;\n  }\n}\n\n/* ---------- Sidebar ---------- */\n.sidebar {\n  width: 264px;\n  flex: none;\n  height: 100%;\n  background: var(--surface);\n  border-right: 1px solid #e9e8e4;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.18s ease;\n}\n\n/* Collapsed rail — icons only, labels and workspace text hidden.\n   Double-class selector keeps this winning over the responsive\n   `@media (max-width: 860px) .sidebar { width: 220px }` rule. */\n.sidebar.sidebar-collapsed {\n  width: 68px;\n}\n\n.sidebar-collapsed .sidebar-workspace,\n.sidebar-collapsed .nav-item span,\n.sidebar-collapsed .nav-section-title {\n  display: none;\n}\n\n.sidebar-collapsed .sidebar-header {\n  justify-content: center;\n  padding: 16px 0 10px;\n}\n\n.sidebar-collapsed .sidebar-nav {\n  padding: 6px 10px 12px;\n}\n\n.sidebar-collapsed .nav-section {\n  margin-top: 8px;\n}\n\n/* In the icon rail there's no room to toggle sections, so always show every\n   item regardless of its expanded/collapsed state — snap open, no animation. */\n.sidebar-collapsed .nav-collapse {\n  grid-template-rows: 1fr;\n  transition: none;\n}\n\n.sidebar-collapsed .nav-item {\n  justify-content: center;\n  gap: 0;\n  padding: 9px 0;\n}\n\n.sidebar-collapsed .sidebar-footer {\n  padding: 10px;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  /* Extra left padding so the workspace name sits off the sidebar edge. */\n  padding: 16px 14px 10px 24px;\n}\n\n.logo-mark-lg {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  font-size: 20px;\n}\n\n.sidebar-workspace {\n  flex: 1;\n  min-width: 0;\n}\n\n.workspace-name {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1.2;\n  color: #1c1917;\n}\n\n.workspace-plan {\n  font-size: 13px;\n  color: #8b8781;\n}\n\n.workspace-switch {\n  background: transparent;\n  border: none;\n  color: #a8a29e;\n  padding: 4px;\n  border-radius: 6px;\n  display: inline-flex;\n}\n\n.workspace-switch svg {\n  width: 18px;\n  height: 18px;\n}\n\n.workspace-switch:hover {\n  background: #eceae6;\n  color: #57534e;\n}\n\n.sidebar-nav {\n  flex: 1;\n  /* Without min-height:0 a flex child keeps min-height:auto, growing to fit\n     all items so overflow-y never engages — this lets the nav shrink and scroll. */\n  min-height: 0;\n  overflow-y: auto;\n  padding: 6px 12px 12px;\n  /* Keep the nav scrollable but hide the scrollbar chrome. */\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* legacy Edge/IE */\n}\n\n.sidebar-nav::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n  display: none; /* Chrome/Safari */\n}\n\n.nav-section {\n  margin-top: 16px;\n}\n\n.nav-section:first-child {\n  margin-top: 4px;\n}\n\n/* Animated collapse wrapper — the grid-rows 0fr→1fr trick smoothly animates\n   height without needing to know the content's pixel height. */\n.nav-collapse {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.24s ease;\n}\n\n.nav-section.open > .nav-collapse,\n.nav-group.open > .nav-collapse {\n  grid-template-rows: 1fr;\n}\n\n.nav-collapse-inner {\n  min-height: 0;\n  overflow: hidden;\n  /* Breathing room so active items' rounded shadows aren't clipped by the\n     overflow needed for the height animation. */\n  padding: 1px 4px;\n  margin: 0 -4px;\n}\n\n.nav-section-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  border: none;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #a8a29e;\n  padding: 4px 10px 6px;\n  cursor: pointer;\n  transition: color 0.12s;\n}\n\n.nav-section-title:hover {\n  color: #78716c;\n}\n\n.nav-section-caret {\n  width: 14px;\n  height: 14px;\n  margin-left: auto;\n  color: #a8a29e;\n  transition: transform 0.15s ease;\n}\n\n.nav-section:not(.open) .nav-section-caret {\n  transform: rotate(-90deg);\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 10px;\n  border-radius: 10px;\n  color: #44403c;\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none;\n  margin-bottom: 2px;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.nav-item svg {\n  width: 20px;\n  height: 20px;\n  color: #78716c;\n  flex: none;\n  transition: color 0.15s ease;\n}\n\n.nav-item:hover {\n  background: #eceae6;\n}\n\n.nav-item.active {\n  background: #ffffff;\n  color: #1c1917;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(28, 25, 23, 0.1), 0 1px 3px rgba(28, 25, 23, 0.06);\n}\n\n.nav-item.active svg {\n  color: #1c1917;\n}\n\n/* ---------- Nav submenus ---------- */\n.nav-parent {\n  width: 100%;\n  background: transparent;\n  border: none;\n  text-align: left;\n  font: inherit;\n}\n\n.nav-parent.active-parent {\n  color: #1c1917;\n}\n\n.nav-caret {\n  width: 16px;\n  height: 16px;\n  margin-left: auto;\n  color: #a8a29e;\n  transition: transform 0.15s ease;\n}\n\n.nav-group.open .nav-caret {\n  transform: rotate(180deg);\n}\n\n/* Indented child links, connected by a vertical guide line. */\n.nav-submenu {\n  position: relative;\n  margin: 2px 0 4px;\n  padding-left: 30px;\n}\n\n.nav-submenu::before {\n  content: '';\n  position: absolute;\n  left: 19px;\n  top: 2px;\n  bottom: 2px;\n  width: 1px;\n  background: #dcdad5;\n}\n\n.nav-subitem {\n  position: relative;\n  display: block;\n  padding: 8px 10px;\n  border-radius: 8px;\n  color: #78716c;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: background 0.12s, color 0.12s;\n}\n\n.nav-subitem:hover {\n  background: #eceae6;\n  color: #44403c;\n}\n\n.nav-subitem.active {\n  color: #1c1917;\n  font-weight: 600;\n}\n\n/* Dark indicator bar overlaying the guide line for the active child. */\n.nav-subitem.active::before {\n  content: '';\n  position: absolute;\n  left: -11px;\n  top: 6px;\n  bottom: 6px;\n  width: 2px;\n  border-radius: 2px;\n  background: #1c1917;\n}\n\n/* Collapsed rail: no chevrons, no expanded submenus. */\n.sidebar-collapsed .nav-caret,\n.sidebar-collapsed .nav-submenu {\n  display: none;\n}\n\n.sidebar-footer {\n  border-top: 1px solid #e9e8e4;\n  background: #f0efec;\n  padding: 10px 12px;\n}\n\n/* ---------- Main content ---------- */\n.main {\n  flex: 1;\n  height: 100%;\n  overflow-y: auto;\n  background: var(--surface-2);\n  display: flex;\n  flex-direction: column;\n}\n\n.main-topbar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  background: var(--topbar-bg);\n  backdrop-filter: blur(6px);\n  z-index: 20;\n}\n\n/* Global search, centered on the true viewport center (not just the content\n   area): the topbar starts after the sidebar, so we pull the centering point\n   back by the sidebar's width. Vertically centered within the topbar. */\n.topbar-search {\n  position: absolute;\n  left: calc(50vw - var(--sidebar-w));\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(460px, 40vw);\n  padding: 8px 14px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  color: var(--text-sub);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.topbar-search svg {\n  width: 16px;\n  height: 16px;\n  flex: none;\n}\n\n.topbar-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: var(--text);\n  outline: none;\n}\n\n.topbar-search-input::placeholder {\n  color: var(--muted);\n}\n\n.topbar-search:focus-within {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n/* No room to center a search on narrow screens — hide it. */\n@media (max-width: 760px) {\n  .topbar-search {\n    display: none;\n  }\n}\n\n/* ---------- Topbar utility icons ---------- */\n.topbar-icons {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-right: 6px;\n}\n\n.icon-btn {\n  position: relative;\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border: none;\n  background: transparent;\n  border-radius: 9px;\n  color: var(--text-sub);\n  transition: background 0.12s, color 0.12s;\n}\n\n.icon-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.icon-btn:hover {\n  background: var(--surface-2);\n  color: var(--text);\n}\n\n.icon-dot {\n  position: absolute;\n  top: 8px;\n  right: 9px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--primary);\n  border: 1.5px solid var(--surface);\n}\n\n/* ---------- User menu ---------- */\n.user-menu {\n  position: relative;\n}\n\n.user-button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 5px 8px 5px 5px;\n  border: none;\n  background: transparent;\n  border-radius: 10px;\n  transition: background 0.12s;\n}\n\n.user-button:hover {\n  background: var(--surface-2);\n}\n\n.avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #18181b;\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  flex: none;\n}\n\n.user-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.2;\n}\n\n.user-button .user-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.user-role {\n  font-size: 12px;\n  color: var(--text-sub);\n}\n\n.user-caret {\n  width: 16px;\n  height: 16px;\n  color: var(--muted);\n  transition: transform 0.15s;\n}\n\n.user-caret.up {\n  transform: rotate(180deg);\n}\n\n.user-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 244px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);\n  padding: 6px;\n  z-index: 50;\n  transform-origin: top right;\n  animation: menuReveal 0.16s ease;\n}\n\n/* The exact reverse of menuReveal. A conditionally-rendered popover unmounts\n   instantly, so closing looked like a hard cut against a 0.16s open; the menu\n   keeps itself mounted for the length of this animation instead. */\n@keyframes menuHide {\n  from {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.98);\n  }\n}\n\n/* Reveal animation for popover menus (plays on mount, since they render\n   conditionally). */\n@keyframes menuReveal {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.dropdown-header {\n  padding: 10px 12px 12px;\n}\n\n.dropdown-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.dropdown-role {\n  font-size: 13px;\n  color: var(--text-sub);\n  margin-top: 2px;\n}\n\n.dropdown-email {\n  font-size: 13px;\n  color: var(--muted);\n  margin-top: 2px;\n  word-break: break-all;\n}\n\n.dropdown-divider {\n  height: 1px;\n  background: var(--border);\n  margin: 4px 0;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 9px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text);\n  transition: background 0.12s;\n}\n\n.dropdown-item:hover {\n  background: var(--surface-2);\n}\n\n.dropdown-item.danger {\n  color: #dc2626;\n}\n\n.dropdown-item.danger:hover {\n  background: #fef2f2;\n}\n\n.page {\n  padding: 24px;\n  max-width: 1400px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.page-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.page-subtitle {\n  margin: 4px 0 0;\n  color: var(--text-sub);\n  font-size: 14px;\n}\n\n/* ---------- Segment cards ---------- */\n.segment-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.segment-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 20px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  text-decoration: none;\n  color: inherit;\n  transition: border-color 0.15s, transform 0.05s;\n}\n\n.segment-card:hover {\n  border-color: var(--primary);\n}\n\n.segment-card:active {\n  transform: translateY(1px);\n}\n\n.segment-icon {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: var(--primary-tint);\n  color: var(--primary);\n  display: grid;\n  place-items: center;\n  flex: none;\n}\n\n.segment-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.segment-body {\n  flex: 1;\n}\n\n.segment-count {\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.segment-label {\n  font-size: 13px;\n  color: var(--text-sub);\n}\n\n.segment-arrow {\n  color: var(--muted);\n  font-size: 18px;\n}\n\n/* ---------- Placeholder ---------- */\n.placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 64px 24px;\n  border: 1px dashed var(--border);\n  border-radius: var(--radius);\n  background: var(--surface-2);\n}\n\n.placeholder-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  display: grid;\n  place-items: center;\n  color: var(--primary);\n}\n\n.placeholder-icon svg {\n  width: 26px;\n  height: 26px;\n}\n\n.placeholder h2 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.placeholder p {\n  margin: 0;\n  max-width: 380px;\n  color: var(--text-sub);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* ---------- Charts (Performance pages) ---------- */\n.chart-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.chart-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 4px;\n}\n\n.chart-card-sub {\n  font-size: 12.5px;\n  color: var(--text-sub);\n  margin: 0 0 16px;\n}\n\n.chart-wrap {\n  position: relative;\n}\n\n.chart-svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.chart-grid {\n  stroke: var(--border);\n  stroke-width: 1;\n  stroke-dasharray: 3 3;\n}\n\n.chart-axis {\n  stroke: var(--border);\n  stroke-width: 1;\n}\n\n.chart-grid-label,\n.chart-x-label {\n  font-size: 10px;\n  fill: var(--muted);\n}\n\n.chart-bar {\n  fill: var(--primary);\n  transition: opacity 0.1s ease;\n}\n\n.chart-bar.hovered {\n  fill: var(--primary-dark);\n}\n\n.chart-tooltip {\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n  background: var(--text);\n  color: #fff;\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 5;\n}\n\n.chart-tooltip-label {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 11px;\n}\n\n.chart-tooltip-value {\n  font-weight: 600;\n}\n\n.hbar-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.hbar-row {\n  display: grid;\n  grid-template-columns: 220px 1fr 64px;\n  align-items: center;\n  gap: 12px;\n}\n\n.hbar-label {\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.hbar-sub {\n  color: var(--text-sub);\n  font-weight: 400;\n  margin-left: 6px;\n  font-size: 12px;\n}\n\n.hbar-track {\n  background: var(--surface-2);\n  border-radius: 4px;\n  height: 14px;\n  overflow: hidden;\n}\n\n.hbar-fill {\n  height: 100%;\n  border-radius: 4px;\n  min-width: 3px;\n}\n\n.hbar-value {\n  font-size: 12.5px;\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n  color: var(--text-sub);\n}\n\n.funnel-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.funnel-conversion {\n  font-size: 11.5px;\n  color: var(--muted);\n  padding-left: 232px;\n}\n\n@media (max-width: 720px) {\n  .hbar-row {\n    grid-template-columns: 120px 1fr 56px;\n  }\n\n  .funnel-conversion {\n    padding-left: 132px;\n  }\n}\n\n/* ---------- Settings & integrations ---------- */\n.settings-grid {\n  display: grid;\n  gap: 20px;\n  max-width: 760px;\n}\n\n.settings-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 20px;\n}\n\n.settings-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 2px;\n}\n\n.settings-card-sub {\n  font-size: 12.5px;\n  color: var(--text-sub);\n  margin: 0 0 16px;\n}\n\n.settings-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 0;\n  border-top: 1px solid var(--border);\n  font-size: 13.5px;\n}\n\n.settings-row:first-of-type {\n  border-top: 0;\n}\n\n.settings-row-label {\n  color: var(--text-sub);\n}\n\n.integration-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.integration-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--primary-tint);\n  color: var(--primary-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.integration-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.integration-name {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.integration-sub {\n  font-size: 12.5px;\n  color: var(--text-sub);\n}\n\n.integration-note {\n  background: var(--surface-2);\n  border: 1px dashed var(--border);\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 12.5px;\n  color: var(--text-sub);\n  line-height: 1.5;\n}\n\n.integration-note code {\n  font-size: 11.5px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 1px 5px;\n}\n\n/* ---------- Inbox ---------- */\n.inbox-toolbar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.inbox-address {\n  font-size: 12.5px;\n  color: var(--text-sub);\n  margin-left: auto;\n}\n\n.mail-row td {\n  vertical-align: top;\n}\n\n.mail-from {\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n.mail-subject {\n  font-weight: 500;\n}\n\n.mail-snippet {\n  color: var(--text-sub);\n  font-size: 12.5px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n}\n\n.mail-unread-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--primary);\n  margin-right: 8px;\n}\n\n.placeholder-tag {\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--primary-dark);\n  background: var(--primary-tint);\n  border: 1px solid #bfdbfe;\n  padding: 3px 10px;\n  border-radius: 999px;\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 860px) {\n  .sidebar {\n    width: 220px;\n  }\n}\n\n@media (max-width: 720px) {\n  .kpi-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .segment-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---------- Dark theme ----------\n   Variables flip on <html data-theme=\"dark\"> (set by ThemeProvider), plus\n   targeted overrides for the components that use hardcoded light-mode colors\n   (sidebar, badges, notes). */\n:root[data-theme='dark'] {\n  /* Dark-render native form controls so unchecked checkboxes / select popups\n     aren't glowing white against the dark UI. */\n  color-scheme: dark;\n  /* Neutral (unsaturated) greys — no blue cast. Brand accent (--primary)\n     stays blue since it's the shared brand colour in both themes. */\n  --bg: #0a0a0a;\n  --surface: #242424;\n  --surface-2: #151515;\n  --border: #333333;\n  --table-line: rgba(255, 255, 255, 0.09);\n  --text: #f5f5f5;\n  --text-sub: #a3a3a3;\n  --muted: #737373;\n  --primary: #3C87F7;\n  --primary-dark: #7FB0FA;\n  --primary-tint: rgba(60, 135, 247, 0.16);\n  --shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3);\n  --map-base: #1f1f1f;\n  --map-accent: #3C87F7;\n  --map-null: #171717;\n  --map-stroke: #0a0a0a;\n  --topbar-bg: rgba(21, 21, 21, 0.85);\n  --scrollbar-thumb: rgba(255, 255, 255, 0.13);\n  --scrollbar-thumb-hover: rgba(255, 255, 255, 0.26);\n}\n\n:root[data-theme='dark'] .sidebar {\n  background: #0d0d0d;\n  border-right-color: #242424;\n}\n\n:root[data-theme='dark'] .sidebar-footer {\n  background: #0d0d0d;\n  border-top-color: #242424;\n}\n\n:root[data-theme='dark'] .workspace-switch:hover {\n  background: #242424;\n  color: var(--text);\n}\n\n:root[data-theme='dark'] .nav-item.active {\n  background: #242424;\n}\n\n:root[data-theme='dark'] .nav-parent.active-parent,\n:root[data-theme='dark'] .nav-subitem.active {\n  color: #f5f5f5;\n}\n\n:root[data-theme='dark'] .nav-submenu::before {\n  background: #333333;\n}\n\n:root[data-theme='dark'] .nav-subitem.active::before {\n  background: #f5f5f5;\n}\n\n:root[data-theme='dark'] .nav-subitem:hover {\n  background: #242424;\n  color: #e5e5e5;\n}\n\n:root[data-theme='dark'] .login-error {\n  background: rgba(220, 38, 38, 0.15);\n  color: #fca5a5;\n  border-color: rgba(220, 38, 38, 0.4);\n}\n\n:root[data-theme='dark'] .enrich-bar {\n  background: rgba(60, 135, 247, 0.12);\n  border-color: rgba(60, 135, 247, 0.35);\n}\n\n:root[data-theme='dark'] .enrich-status {\n  background: rgba(34, 197, 94, 0.12);\n  border-color: rgba(34, 197, 94, 0.35);\n  color: #4ade80;\n}\n\n:root[data-theme='dark'] .badge-enriched {\n  background: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n}\n\n:root[data-theme='dark'] .badge-new {\n  background: rgba(59, 130, 246, 0.16);\n  color: #93c5fd;\n}\n\n:root[data-theme='dark'] .badge-contacted {\n  background: rgba(139, 92, 246, 0.16);\n  color: #c4b5fd;\n}\n\n:root[data-theme='dark'] .badge-quoted {\n  background: rgba(234, 179, 8, 0.16);\n  color: #fde047;\n}\n\n:root[data-theme='dark'] .badge-scheduled {\n  background: rgba(6, 182, 212, 0.16);\n  color: #67e8f9;\n}\n\n:root[data-theme='dark'] .badge-won {\n  background: rgba(34, 197, 94, 0.16);\n  color: #4ade80;\n}\n\n:root[data-theme='dark'] .badge-lost {\n  background: rgba(220, 38, 38, 0.16);\n  color: #fca5a5;\n}\n\n:root[data-theme='dark'] .chip-auto {\n  background: rgba(60, 135, 247, 0.14);\n  border-color: rgba(60, 135, 247, 0.35);\n}\n\n:root[data-theme='dark'] .leads-table tbody tr.selected {\n  background: rgba(60, 135, 247, 0.1);\n}\n\n:root[data-theme='dark'] .leads-table tbody tr.selected:hover {\n  background: rgba(60, 135, 247, 0.16);\n}\n\n/* Tooltip keeps its own fixed dark chrome in both themes. */\n.chart-tooltip {\n  background: #151515;\n  color: #fafafa;\n  border: 1px solid #333333;\n}\n\n/* ---------- Assistant drawer ---------- */\n.assistant-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.35);\n  z-index: 40;\n  opacity: 0;\n  animation: assistant-fade 0.2s ease forwards;\n}\n\n@keyframes assistant-fade {\n  to {\n    opacity: 1;\n  }\n}\n\n/* Chart marks rise from the baseline on mount (transform-box:fill-box +\n   transform-origin:bottom put the scale origin on the axis, not the viewBox). */\n@keyframes barGrow {\n  from {\n    transform: scaleY(0);\n  }\n  to {\n    transform: scaleY(1);\n  }\n}\n\n/* Dashboard tab panels: cross-fade in instead of snapping. */\n@keyframes tabIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Indeterminate progress bar (AI sequence discovery). */\n@keyframes seqbar {\n  0% {\n    transform: translateX(-120%);\n  }\n  100% {\n    transform: translateX(320%);\n  }\n}\n\n/* Toast slide-in (ToastHost, bottom-right). */\n@keyframes toastIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.assistant-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: min(380px, 92vw);\n  background: var(--surface);\n  border-left: 1px solid var(--border);\n  box-shadow: -8px 0 30px rgba(2, 6, 23, 0.18);\n  z-index: 41;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.28s cubic-bezier(0.32, 0.72, 0.24, 1);\n}\n\n.assistant-panel.open {\n  transform: translateX(0);\n}\n\n.assistant-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 18px;\n  border-bottom: 1px solid var(--border);\n}\n\n.assistant-head-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: var(--primary-tint);\n  color: var(--primary-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.assistant-title {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.assistant-sub {\n  font-size: 11.5px;\n  color: var(--text-sub);\n}\n\n.assistant-close {\n  margin-left: auto;\n}\n\n.assistant-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.assistant-msg {\n  max-width: 88%;\n  border-radius: 12px;\n  padding: 9px 12px;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.assistant-msg.from-user {\n  align-self: flex-end;\n  background: var(--primary);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.assistant-msg.from-assistant {\n  align-self: flex-start;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-bottom-left-radius: 4px;\n}\n\n.assistant-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.assistant-suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 0 16px 10px;\n}\n\n.assistant-input-row {\n  display: flex;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border);\n}\n\n.assistant-input-row input {\n  flex: 1;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 9px 12px;\n  font-size: 13px;\n  background: var(--surface);\n  color: var(--text);\n}\n\n.assistant-input-row input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n/* ---------- Notifications dropdown ---------- */\n.notif-menu {\n  position: relative;\n}\n\n.notif-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  width: 340px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: 0 12px 32px rgba(2, 6, 23, 0.16);\n  z-index: 30;\n  overflow: hidden;\n  transform-origin: top right;\n  animation: menuReveal 0.16s ease;\n}\n\n.notif-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border);\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.notif-mark {\n  font-size: 12px;\n  color: var(--primary-dark);\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.notif-list {\n  max-height: 340px;\n  overflow-y: auto;\n}\n\n.notif-item {\n  display: flex;\n  gap: 10px;\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border);\n  font-size: 12.5px;\n  align-items: flex-start;\n}\n\n.notif-item:last-child {\n  border-bottom: 0;\n}\n\n.notif-item.unread {\n  background: var(--primary-tint);\n}\n\n.notif-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--primary);\n  margin-top: 5px;\n  flex-shrink: 0;\n}\n\n.notif-dot.read {\n  background: var(--border);\n}\n\n.notif-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.notif-label {\n  font-weight: 600;\n}\n\n.notif-detail {\n  color: var(--text-sub);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.notif-time {\n  color: var(--muted);\n  font-size: 11.5px;\n  white-space: nowrap;\n}\n\n.notif-empty {\n  padding: 22px 14px;\n  text-align: center;\n  color: var(--text-sub);\n  font-size: 12.5px;\n}\n\n.notif-footer {\n  border-top: 1px solid var(--border);\n  padding: 9px 14px;\n  text-align: center;\n}\n\n/* ---------- MultiStepForm wizard ---------- */\n.logo-mark-sm {\n  width: 26px;\n  height: 26px;\n  font-size: 13px;\n  border-radius: 7px;\n}\n\n.msf {\n  display: flex;\n  min-height: 100vh;\n  background: var(--surface);\n  color: var(--text);\n}\n\n/* Wizard content area (sidebar stays; wizard fills the rest, no Topbar/padding). */\n.main-flush {\n  padding: 0;\n}\n\n/* When a wizard renders inside the app layout, fill the available space beside\n   the sidebar instead of forcing a second full-viewport-height scroll region. */\n.main-flush .msf {\n  flex: 1;\n  min-height: 0;\n}\n\n.msf-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px 7px 9px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--text-sub);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.msf-back:hover {\n  background: var(--surface-2);\n  color: var(--text);\n  border-color: var(--text-sub);\n}\n\n.msf-back svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Left visual panel */\n.msf-aside {\n  flex: 1 1 50%;\n  position: relative;\n  overflow: hidden;\n  background: var(--surface-2);\n  border-right: 1px solid var(--border);\n}\n\n.msf-stage {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  padding-left: 7%;\n  perspective: 1800px;\n  overflow: hidden;\n}\n\n.msf-preview-card {\n  width: 132%;\n  transform: rotateY(24deg) rotateX(6deg) rotateZ(-3deg);\n  transform-origin: left center;\n  filter: drop-shadow(0 30px 60px rgba(2, 6, 23, 0.14));\n}\n\n/* Right form panel */\n.msf-main {\n  flex: 1 1 50%;\n  display: flex;\n  flex-direction: column;\n  padding: 26px 44px 30px;\n  min-width: 0;\n}\n\n.msf-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.msf-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--text);\n  color: var(--surface);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.msf-progress {\n  display: flex;\n  gap: 7px;\n  width: 210px;\n  margin: 10px auto 0;\n}\n\n.msf-progress-seg {\n  flex: 1;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--border);\n  transition: background 0.2s ease;\n}\n\n.msf-progress-seg.filled {\n  background: var(--text);\n}\n\n.msf-scroll {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 32px 0;\n}\n\n.msf-body {\n  width: 100%;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.msf-title {\n  font-size: 27px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin: 0 0 14px;\n}\n\n.msf-desc {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--text-sub);\n  margin: 0;\n  max-width: 54ch;\n}\n\n.msf-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px 22px;\n  margin-top: 30px;\n}\n\n.msf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.msf-field.full,\n.msf-help,\n.msf-divider {\n  grid-column: 1 / -1;\n}\n\n.msf-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.msf-input,\n.msf-select {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface-2);\n  font-size: 14px;\n  color: var(--text);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.msf-input::placeholder {\n  color: var(--muted);\n}\n\n.msf-input:focus,\n.msf-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(60, 135, 247, 0.2);\n}\n\n.msf-textarea {\n  resize: vertical;\n  min-height: 96px;\n  font-family: inherit;\n  line-height: 1.5;\n}\n\n.msf-select-wrap {\n  position: relative;\n}\n\n.msf-select {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 38px;\n  cursor: pointer;\n}\n\n.msf-select-caret {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: var(--muted);\n  pointer-events: none;\n}\n\n.msf-help {\n  font-size: 12.5px;\n  color: var(--text-sub);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.msf-divider {\n  height: 1px;\n  background: var(--border);\n  margin: 6px 0;\n}\n\n.msf-error {\n  font-size: 12px;\n  color: #dc2626;\n}\n\n.msf-field.error .msf-input,\n.msf-field.error .msf-select {\n  border-color: #dc2626;\n}\n\n.msf-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 560px;\n  margin: 0 auto;\n  padding-top: 16px;\n}\n\n.msf-continue {\n  min-width: 120px;\n  justify-content: center;\n}\n\n/* Aside mock content (dashboard / sequence previews) */\n.mock {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  box-shadow: var(--shadow);\n  padding: 22px;\n  width: 640px;\n  max-width: 100%;\n}\n\n.mock-eyebrow {\n  font-size: 12px;\n  color: var(--text-sub);\n  margin-bottom: 6px;\n}\n\n.mock-greet {\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.mock-sub {\n  font-size: 13px;\n  color: var(--text-sub);\n  margin-top: 4px;\n  margin-bottom: 18px;\n}\n\n.mock-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.mock-tile {\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 14px;\n  background: var(--surface-2);\n}\n\n.mock-tile-label {\n  font-size: 11px;\n  color: var(--text-sub);\n}\n\n.mock-tile-val {\n  font-size: 20px;\n  font-weight: 700;\n  margin-top: 6px;\n}\n\n.mock-bars {\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n  height: 34px;\n  margin-top: 10px;\n}\n\n.mock-bars span {\n  flex: 1;\n  background: var(--primary);\n  border-radius: 2px 2px 0 0;\n  opacity: 0.85;\n}\n\n.mock-seq-step {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid var(--border);\n  font-size: 14px;\n}\n\n.mock-seq-step:first-of-type {\n  border-top: 0;\n}\n\n.mock-seq-day {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--primary-dark);\n  background: var(--primary-tint);\n  border-radius: 999px;\n  padding: 3px 10px;\n  white-space: nowrap;\n}\n\n/* Dark-mode: keep the aside footer dark (it already is) and soften the stage */\n:root[data-theme='dark'] .msf-preview-card {\n  filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.5));\n}\n\n@media (max-width: 900px) {\n  .msf-aside {\n    display: none;\n  }\n  .msf-main {\n    flex-basis: 100%;\n    padding: 24px 24px 28px;\n  }\n  .msf-fields {\n    grid-template-columns: 1fr;\n  }\n  .msf-field.half {\n    grid-column: 1 / -1;\n  }\n}\n\n/* Honor reduced-motion: keep everything functional but instant. */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n  }\n}\n\n/* Conversation-title marquee on the chat history panel: on hover the title\n   scrolls to reveal its full text (distance fed in as --marq) and back. Only\n   overflowing titles set --marq, so short ones don't move. */\n@keyframes marqueeTitle {\n  0%, 12% { transform: translateX(0); }\n  88%, 100% { transform: translateX(var(--marq, 0px)); }\n}\n\n/* ---------- Agent run flowchart (components/FlowCanvas.jsx) ----------\n   The gridded canvas the run is drawn on, plus the two motions that make the\n   graph legible: dashes marching along a LIVE edge (an edge whose target node\n   is running) and a ring breathing around the running card.\n\n   Every colour is a variable with a dark-theme counterpart. A hardcoded grid\n   colour is invisible in one theme or blinding in the other, and this block is\n   appended after the main :root[data-theme='dark'] block on purpose so the\n   dark values win by source order at equal specificity. */\n:root {\n  --flow-dot: rgba(15, 23, 42, 0.12);\n  --flow-rule: rgba(15, 23, 42, 0.035);\n  --flow-edge: #cbd5e1;\n  --flow-edge-muted: rgba(148, 163, 184, 0.75);\n}\n\n:root[data-theme='dark'] {\n  --flow-dot: rgba(255, 255, 255, 0.11);\n  --flow-rule: rgba(255, 255, 255, 0.03);\n  --flow-edge: #3f3f3f;\n  --flow-edge-muted: rgba(115, 115, 115, 0.8);\n}\n\n/* Two layers: a coarse 96px rule for structure and a 24px dot field for\n   texture. background-attachment:local ties the grid to the scrolled content,\n   so panning the flow moves the paper with it rather than sliding the nodes\n   over a fixed backdrop. */\n.flow-grid {\n  background-color: var(--surface);\n  background-image:\n    linear-gradient(to right, var(--flow-rule) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--flow-rule) 1px, transparent 1px),\n    radial-gradient(circle at center, var(--flow-dot) 1.05px, transparent 1.15px);\n  background-size: 96px 96px, 96px 96px, 24px 24px;\n  background-position: 0 0, 0 0, 12px 12px;\n  background-attachment: local, local, local;\n}\n\n@keyframes flowMarch {\n  to {\n    stroke-dashoffset: -32;\n  }\n}\n\n.flow-edge-live {\n  animation: flowMarch 0.9s linear infinite;\n}\n\n@keyframes flowBreathe {\n  0%,\n  100% {\n    opacity: 0.16;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.flow-pulse {\n  opacity: 0.16;\n  animation: flowBreathe 1.6s cubic-bezier(0.32, 0.72, 0.24, 1) infinite;\n}\n\n/* Reduced motion: the global rule near the top of this file already collapses\n   every animation to ~0ms, which would freeze the marching dashes MID-GAP and\n   leave a live edge looking like a broken one. So the dashes are removed\n   outright (a live edge stays a solid, heavier, primary-coloured wire) and the\n   breathing ring settles at a readable steady opacity. Nothing moves; nothing\n   loses its meaning. */\n@media (prefers-reduced-motion: reduce) {\n  .flow-edge-live {\n    animation: none;\n    stroke-dasharray: none;\n    stroke: none;\n  }\n  .flow-pulse {\n    animation: none;\n    opacity: 0.5;\n  }\n}\n\n/* ---------- Draft narrative (components/DraftFlowView.jsx, \"Main\" view) ----\n   Each big sentence enters like marketing copy: blurred, low, transparent,\n   then settling. Stagger comes from an inline animation-delay per line, and\n   fill-mode 'both' holds the hidden from-state through that delay.\n\n   .narrative-line starts hidden so a section below the fold has nothing to\n   flash before its IntersectionObserver fires; .narrative-line-in is added by\n   the component when the section scrolls into view (once). */\n@keyframes narrativeLineIn {\n  from {\n    opacity: 0;\n    filter: blur(14px);\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    filter: blur(0);\n    transform: translateY(0);\n  }\n}\n\n.narrative-line {\n  opacity: 0;\n}\n\n.narrative-line-in {\n  animation: narrativeLineIn 700ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n/* Reduced motion: everything simply visible — no entrance, no blur, no\n   translate. The component also skips its observer and delays, but the CSS\n   guarantees it even if a line never gets the -in class. */\n@media (prefers-reduced-motion: reduce) {\n  .narrative-line {\n    opacity: 1;\n  }\n  .narrative-line-in {\n    animation: none;\n    filter: none;\n    transform: none;\n  }\n}\n\n/* Activity → detail page: the rows behind a number slide in from the right and\n   back out again, so the tiles and their evidence read as two places rather\n   than one long scroll. A keyframe rather than a class-toggled transform: the\n   toggle depends on the element being painted off-screen for one frame first,\n   which a background tab (rAF throttled) collapses into a jump. */\n@keyframes detailIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes detailOut {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(100%);\n  }\n}\n\n/* The summary steps aside under the incoming page, giving the two views a\n   spatial relationship instead of a cut. */\n@keyframes summaryAside {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(-32px);\n    opacity: 0;\n  }\n}\n\n@keyframes summaryBack {\n  from {\n    transform: translateX(-32px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.detail-enter {\n  animation: detailIn 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;\n}\n\n.detail-exit {\n  animation: detailOut 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;\n}\n\n.summary-aside {\n  animation: summaryAside 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;\n}\n\n.summary-back {\n  animation: summaryBack 300ms cubic-bezier(0.32, 0.72, 0.24, 1) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .detail-enter,\n  .detail-exit,\n  .summary-aside,\n  .summary-back {\n    animation-duration: 1ms;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
